import { Injectable } from '@angular/core'
import { Platform } from '@ionic/angular'
import { SQLite, SQLiteObject } from '@ionic-native/sqlite/ngx'
import { UtilService } from './util.service'
import { StaticDataService } from './static-data.service'
import { DeviceOfflineDetailViewModels } from '../_models/offline/DeviceOfflineDetailViewModels'
import { DeviceArchivedWorkPermitDetail } from '../_models/offline/DeviceArchivedWorkPermitDetail'
import { DeviceArchivedDocumentDetail } from '../_models/offline/DeviceArchivedDocumentDetail'
import { DeviceCompanyUserDetail } from '../_models/offline/DeviceCompanyUserDetail'
import { DeviceEntityData } from '../_models/offline/DeviceEntityData'
import { DeviceUserDetail } from '../_models/offline/DeviceUserDetail'
import { DeviceUserQualificationDetail } from '../_models/offline/DeviceUserQualificationDetail'
import { DeviceGuestUserDetail } from '../_models/offline/DeviceGuestUserDetail'
import { DeviceAvailableDocumentDetail } from '../_models/offline/DeviceAvailableDocumentDetail'
import { DeviceAvailableFormDetail } from '../_models/offline/DeviceAvailableFormDetail'
import { DeviceArchivedFormDetail } from '../_models/offline/DeviceArchivedFormDetail'
import { DeviceAvailableWorkPermitDetail } from '../_models/offline/DeviceAvailableWorkPermitDetail'
import { DeviceLiveWorkPermitDetail } from '../_models/offline/DeviceLiveWorkPermitDetail'
import { DeviceFormDetail } from '../_models/offline/DeviceFormDetail'
import { DeviceFormAttachmentDetail } from '../_models/offline/DeviceFormAttachmentDetail'
import { DeviceEvacuationDetail } from '../_models/offline/DeviceEvacuationDetail'
import { DeviceUserCheckInQualificationDetail } from '../_models/offline/DeviceUserCheckInQualificationDetail'
import { DeviceLocationDetail } from '../_models/offline/DeviceLocationDetail'
import { DeviceProjectDetail } from '../_models/offline/DeviceProjectDetail'
import { DeviceInventoryItemDetail } from '../_models/offline/DeviceInventoryItemDetail'
import { DeviceUserCheckinDetail } from '../_models/offline/DeviceUserCheckinDetail'
import { DeviceCheckInInductionDetail } from '../_models/offline/DeviceCheckInInductionDetail'
import { DeviceCheckInInductionItemDetail } from '../_models/offline/DeviceCheckInInductionItemDetail'
import { DeviceGuestUserCheckinDetail } from '../_models/offline/DeviceGuestUserCheckinDetail'
import { DeviceCheckInGuestInductionDetail } from '../_models/offline/DeviceCheckInGuestInductionDetail'
import { DeviceCheckInGuestInductionItemDetail } from '../_models/offline/DeviceCheckInGuestInductionItemDetail'
import { DeviceCompanyUserGroupDetail } from '../_models/offline/DeviceCompanyUserGroupDetail'
import { DeviceHAVManufacturerDetail } from '../_models/offline/DeviceHAVManufacturerDetail'
import { DeviceHAVTypeDetail } from '../_models/offline/DeviceHAVTypeDetail'
import { DeviceHAVModelDetail } from '../_models/offline/DeviceHAVModelDetail'
import { DeviceRiskItemDetail } from '../_models/offline/DeviceRiskItemDetail'
import { DeviceHazardItemDetail } from '../_models/offline/DeviceHazardItemDetail'
import { DeviceEntityDetail } from '../_models/deviceEntityDetail'
import { DeviceFormBuilderDetail } from '../_models/offline/DeviceFormBuilderDetail'
import { EntityItem } from '../_models/entityItem'
import { EnumService } from './enum.service'
import * as moment from 'moment'
import { FilehandlerService } from './filehandler.service'
import { Capacitor } from '@capacitor/core'
import { DeviceUserLastCheckinDetail } from '../_models/offline/DeviceUserLastCheckinDetail'
import { DeviceGuestUserLastCheckinDetail } from '../_models/offline/DeviceGuestUserLastCheckinDetail'
import { DeviceDetailData } from '../_models/offline/DeviceDetailData'
import { environment } from 'src/environments/environment'
import { SharedDataService } from './shared-data.service'
import { Injector } from '@angular/core'
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer/ngx'
import { File as localFile } from '@ionic-native/file/ngx'
import { ApiService } from './api.service'

declare var window: any

@Injectable({
  providedIn: 'root',
})
export class OfflineManagerService {
  private dbInstance: SQLiteObject
  private documentsToReDownload: Set<number> = new Set()
  readonly db_name: string = 'compliancegenie.db'
  readonly db_table: string = 'userTable'

  public offlineDeviceDetailData: DeviceDetailData = null
  private injector: Injector

  constructor(
    private platform: Platform,
    private sqlite: SQLite,
    private filehandlerService: FilehandlerService,
    injector: Injector,
    private fileTransfer: FileTransfer,
    private file: localFile,
  ) {
    this.injector = injector
    if (!UtilService.isWebApp() && !environment.isFormPreview) {
      this.getDeviceDetail().then((deviceDetailData: DeviceDetailData) => {
        this.offlineDeviceDetailData = deviceDetailData
      })
    }
  }

  public dbSetUp() {
    try {
      if (!UtilService.isWebApp() && !environment.isFormPreview) {
        if (UtilService.isLocalHost()) {
          this.dbInstance = window.openDatabase(
            this.db_name,
            '1.0',
            'My WebSQL Database',
            2 * 1024 * 1024,
          )
          this.createTables()
          this.migrateDatabase()
        } else {
          this.platform.ready().then(() => {
            this.sqlite
              .create({
                name: this.db_name,
                location: 'default',
              })
              .then((sqLite: SQLiteObject) => {
                this.dbInstance = sqLite
                this.createTables()
                this.migrateDatabase()
                // Reload offlineDeviceDetailData after DB is ready (handles app reopen without sync)
                setTimeout(() => {
                  this.getDeviceDetail().then((detail: DeviceDetailData) => {
                    if (detail) {
                      this.offlineDeviceDetailData = detail;
                    }
                  }).catch((_err) => {});
                }, 1000);
              })
              .catch((error) => alert(JSON.stringify(error)))
          })
        }
      }
    } catch (error) {}
  }

  migrateDatabase = () => {
    // Add originalFileName column to ImageVideoFiles table if it doesn't exist
    // This migration handles existing databases that don't have this column
    // SQLite doesn't support IF NOT EXISTS for ALTER TABLE ADD COLUMN, so we try and ignore errors
    console.log('🔄 [MIGRATION] Attempting to add originalFileName column to ImageVideoFiles table...');
    this.dbQuery(
      'ALTER TABLE ImageVideoFiles ADD COLUMN originalFileName VARCHAR(255)',
      []
    ).then(() => {
      console.log('✅ [MIGRATION] Successfully added originalFileName column');
    }).catch((error) => {
      console.log('ℹ️ [MIGRATION] originalFileName column already exists or table doesn\'t exist yet');
    });

    const scoringColumns = [
      'isFormScoringEnabled',
      'isShowScoreInApp',
      'isShowTScoreInPDF',
      'isShowSScoreInPDF',
    ];
    scoringColumns.forEach((col) => {
      this.dbQuery(
        `ALTER TABLE DeviceFormBuilderDetails ADD COLUMN ${col} BOOLEAN`,
        []
      ).then(() => {
        console.log(`✅ [MIGRATION] Successfully added ${col} column`);
      }).catch(() => {
        console.log(`ℹ️ [MIGRATION] ${col} column already exists or table doesn't exist yet`);
      });
    });

    this.dbQuery('ALTER TABLE SignOffDetails ADD COLUMN idempotencyKey VARCHAR(255)', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added idempotencyKey column to SignOffDetails'))
      .catch(() => console.log('ℹ️ [MIGRATION] idempotencyKey column already exists in SignOffDetails'));

    this.dbQuery('ALTER TABLE DeviceArchivedForms ADD COLUMN formSubmitDataId INTEGER', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added formSubmitDataId column to DeviceArchivedForms'))
      .catch(() => console.log('ℹ️ [MIGRATION] formSubmitDataId column already exists in DeviceArchivedForms'));

    this.dbQuery('ALTER TABLE DeviceArchivedForms ADD COLUMN signOffDetailId INTEGER', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added signOffDetailId column to DeviceArchivedForms'))
      .catch(() => console.log('ℹ️ [MIGRATION] signOffDetailId column already exists in DeviceArchivedForms'));

    this.dbQuery('ALTER TABLE DeviceArchivedDocuments ADD COLUMN signOffDetailId INTEGER', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added signOffDetailId column to DeviceArchivedDocuments'))
      .catch(() => console.log('ℹ️ [MIGRATION] signOffDetailId column already exists in DeviceArchivedDocuments'));

    this.dbQuery('ALTER TABLE SignOffDetails ADD COLUMN formSubmittedOnline INTEGER DEFAULT 0', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added formSubmittedOnline column to SignOffDetails'))
      .catch(() => console.log('ℹ️ [MIGRATION] formSubmittedOnline column already exists in SignOffDetails'));

    this.dbQuery('ALTER TABLE SignOffDetails ADD COLUMN signOffPayload TEXT', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added signOffPayload column to SignOffDetails'))
      .catch(() => console.log('ℹ️ [MIGRATION] signOffPayload column already exists in SignOffDetails'));

    this.dbQuery('ALTER TABLE SignOffDetails ADD COLUMN fullPayloadJson TEXT', [])
      .then(() => console.log('✅ [MIGRATION] Successfully added fullPayloadJson column to SignOffDetails'))
      .catch(() => console.log('ℹ️ [MIGRATION] fullPayloadJson column already exists in SignOffDetails'));

  }

  dbQuery = (sql: any, values: any = []) => {
    return new Promise((resolve, reject) => {
      try {
        if (UtilService.isWebApp() || environment.isFormPreview) {
          reject({ message: 'Websql not supported in web app' })
        } else {
          if (this.dbInstance) {
            if (!UtilService.isLocalHost()) {
              this.dbInstance.executeSql(sql, values).then(
                (response: any) => {
                  resolve(response)
                },
                (err) => {
                  console.log('QUERY Error ', err)
                  reject(err)
                },
              )
            } else {
              this.dbInstance.transaction((tx) => {
                tx.executeSql(
                  sql,
                  values,
                  (tx, results) => {
                    resolve(results)
                  },
                  (tx, err) => {
                    console.log('QUERY Error ', err)
                    reject(err)
                  },
                )
              })
            }
          } else {
            setTimeout(() => {
              this.dbQuery(sql, values)
            }, 300)
          }
        }
      } catch (error) {}
    })
  }

  createTables = () => {
    StaticDataService.offlineTables.map((data) => {
      if (data.table_name) {
        let columnsList = []
        data.columns.map((item) => {
          columnsList.push(item.name + ' ' + item.type)
        })

        let query =
          'CREATE TABLE IF NOT EXISTS ' +
          data.table_name +
          ' (' +
          columnsList.join(', ') +
          ')'

        this.dbQuery(query, []).then(
          (response: any) => {},
          (err) => {
            console.error(data.table_name + ' Unable to execute sql: ', err)
          },
        )
      }
    })
  }

  convertObjectToColValPlaceholders = (data, table) => {
    const dataCols = []
    const dataVals = []
    const dataValPlaceHolders = []

    let availableColumns = []
    if (table) {
      const tableData = StaticDataService.offlineTables.find(
        (item: any) => item.table_name === table,
      )
      const columns = tableData?.columns || []
      availableColumns = columns.map((item) => item.name)
      availableColumns.shift()
    }
    Object.keys(data).map((colName) => {
      if (availableColumns.indexOf(colName) !== -1) {
        const val = data[colName]

        if (val !== null && val !== '') {
          dataCols.push(colName)
          dataValPlaceHolders.push('?')

          if (UtilService.isArray(val)) {
            dataVals.push(escape(JSON.stringify(val)))
          } else if (UtilService.isObject(val)) {
            dataVals.push(escape(JSON.stringify(val)))
          } else {
            dataVals.push(val)
          }
        }
      }
    })

    return {
      dataCols,
      dataVals,
      dataValPlaceHolders,
    }
  }

  convertObjectToConditionString(obj) {
    let condition = ''
    Object.keys(obj).map((item, key) => {
      if (key > 0) {
        condition = condition + ' AND'
      }
      let conditionValue
      if (typeof obj[item] === 'string') {
        conditionValue = '"' + obj[item] + '"'
      } else if (typeof obj[item] === 'number') {
        conditionValue = obj[item]
      }
      condition = condition + ' ' + item + ' = ' + conditionValue
    })
    return condition
  }

  emptyCond(key: string | Array<string>) {
    const createCond = (key) => {
      return ' (' + key + ' is NULL OR ' + key + ' = 0 OR ' + key + " = '') "
    }
    if (typeof key === 'string') {
      return createCond(key)
    } else if (Array.isArray(key)) {
      const allKeys: Array<string> = []
      key.forEach((element) => {
        allKeys.push(createCond(element))
      })
      return '(' + allKeys.join('AND') + ')'
    }
    return ' '
  }

  checkPreviousSyncDataProgress = () => {
    const syncState = localStorage.getItem(
      EnumService.LocalStorageKeys.OFFLINEMODE_SYNC_STATE,
    )
    if (syncState) {
      switch (syncState) {
        case EnumService.SyncProcessState.OFFLINE_DATA_INSERT_START:
        case EnumService.SyncProcessState.OFFLINE_DATA_DOWNLOAD_START:
          // Only clear tables if there are downloaded files that weren't inserted
          // This means sync actually started downloading but didn't complete
          const offlineDataFiles = localStorage.getItem(
            EnumService.LocalStorageKeys.OFFLINE_DATA_FILES,
          )
          // If there are downloaded files, it means sync was in progress and tables might be empty
          // If no files, sync was cancelled before download, so don't clear tables
          if (offlineDataFiles) {
            this.emptyAllTables(() => {
              // Remove offline data json/zip files
              try {
                const files = JSON.parse(offlineDataFiles)
                files.forEach((fileUrl) => {
                  this.filehandlerService.removeFile(fileUrl)
                })
                localStorage.removeItem(
                  EnumService.LocalStorageKeys.OFFLINE_DATA_FILES,
                )
              } catch (error) {}
            })
          } else {
            // No downloaded files means sync was cancelled before download
            // Just clear the sync state, don't touch the tables
            localStorage.removeItem(
              EnumService.LocalStorageKeys.OFFLINEMODE_SYNC_STATE,
            )
          }
          break

        default:
          break
      }
    }
  }

  /**
   *
   * @param table DB table name
   * @param data Data objects to be inserted
   * @param condition Insert data if condition not match
   */
  insertData = (table, data = {}, condition = {}) => {
    const {
      dataCols,
      dataVals,
      dataValPlaceHolders,
    } = this.convertObjectToColValPlaceholders(data, table)

    let condCols = []
    Object.keys(condition).map((colName) => {
      const val = condition[colName]
      if (val != null) {
        let condState = colName + ' = '
        if (typeof val === 'string') {
          condState = condState + '"' + val + '"'
        } else {
          condState = condState + '' + val
        }
        condCols.push(condState)
      }
    })
    let query =
      'INSERT INTO ' +
      table +
      ' (' +
      dataCols.join(',') +
      ') select ' +
      dataValPlaceHolders.join(',') +
      ''
    if (condCols.length > 0) {
      query =
        query +
        ' WHERE NOT EXISTS(SELECT 1 FROM ' +
        table +
        ' WHERE ' +
        condCols.join(' AND ') +
        ')'
    }

    // Add logging for document inserts to debug issues
    if (table === 'DeviceAvailableDocuments') {
      const dataAny = data as any;
      const conditionAny = condition as any;
      console.log(`💾 [INSERT DATA] Table: ${table}`);
      console.log(`💾 [INSERT DATA] Condition:`, condition);
      console.log(`💾 [INSERT DATA] Query:`, query);
      console.log(`💾 [INSERT DATA] Data keys:`, Object.keys(data));
      console.log(`💾 [INSERT DATA] Data values (key sample):`, {
        documentID: dataAny.documentID,
        documentVersionID: dataAny.documentVersionID,
        parentFolderID: dataAny.parentFolderID,
        locationID: dataAny.locationID,
        projectID: dataAny.projectID,
        inventoryItemID: dataAny.inventoryItemID
      });
      console.log(`💾 [INSERT DATA] Columns to insert:`, dataCols);
      console.log(`💾 [INSERT DATA] Values to insert (first 10):`, dataVals.slice(0, 10));
    }

    return this.dbQuery(query, dataVals)
      .then((result: any) => {
        if (table === 'DeviceAvailableDocuments') {
          const conditionAny = condition as any;
          console.log(`✅ [INSERT DATA] Successfully inserted into ${table}`);
          console.log(`✅ [INSERT DATA] Rows affected:`, result?.rowsAffected || 'unknown');
          console.log(`✅ [INSERT DATA] Insert ID:`, result?.insertId || 'unknown');
          
          // Immediately verify what was actually inserted
          if (conditionAny.documentID && conditionAny.documentVersionID) {
            const verifyQuery = `SELECT documentID, documentVersionID, parentFolderID, locationID, projectID, inventoryItemID, documentTitle FROM DeviceAvailableDocuments WHERE documentID = ${conditionAny.documentID} AND documentVersionID = ${conditionAny.documentVersionID}`;
            this.dbQuery(verifyQuery, []).then((verifyRes: any) => {
              if (verifyRes?.rows?.length > 0) {
                const inserted = this.convertToArray(verifyRes.rows);
                const insertedDocs = inserted.map((d: any) => ({
                  documentID: d.documentID,
                  documentVersionID: d.documentVersionID,
                  parentFolderID: d.parentFolderID,
                  locationID: d.locationID,
                  projectID: d.projectID,
                  inventoryItemID: d.inventoryItemID,
                  documentTitle: d.documentTitle
                }));
                console.log(`✅ [INSERT DATA] Immediately after insert, found:`, insertedDocs);
                // Also log each document individually for easier debugging
                insertedDocs.forEach((doc, idx) => {
                  console.log(`✅ [INSERT DATA] Document ${idx + 1}/${insertedDocs.length}:`, doc);
                });
              } else {
                console.warn(`⚠️ [INSERT DATA] Document not found immediately after insert!`);
              }
            }).catch((verifyErr) => {
              console.error(`❌ [INSERT DATA] Error verifying insert:`, verifyErr);
            });
          }
        }
        return result;
      })
      .catch((error) => {
        if (table === 'DeviceAvailableDocuments') {
          console.error(`❌ [INSERT DATA] Error inserting into ${table}:`, error);
          console.error(`❌ [INSERT DATA] Query was:`, query);
          console.error(`❌ [INSERT DATA] Condition was:`, condition);
        }
        throw error;
      });
  }

  emptyTable = (table, condition = '') => {
    let query =
      'DELETE FROM ' + table + (condition ? ' WHERE ' + condition : '')
    return this.dbQuery(query)
  }

  /**
   * Remove evacuation row after online company-user checkout (mirrors offline insertCheckOutDetails DELETE).
   */
  removeEvacuationForCompanyUserAtEntity = (
    userId: string,
    entity: DeviceEntityDetail,
  ) => {
    if (!userId || !entity) {
      return Promise.resolve(null)
    }
    const base = this.appendEntityCondition(entity)
    if (!base) {
      return Promise.resolve(null)
    }
    const removeQuery =
      'DELETE FROM DeviceEvacuations WHERE ' +
      base +
      ' AND userId = "' +
      userId +
      '"'
    const checkoutOpenCondition =
      '(checkOutDate IS NULL OR checkOutDate="" OR checkOutDate="' +
      StaticDataService.userDefaultDate +
      '")'
    const removeOpenCheckinQuery =
      'DELETE FROM DeviceUserCheckinDetails WHERE ' +
      base +
      ' AND userId = "' +
      userId +
      '" AND ' +
      checkoutOpenCondition +
      ' AND NOT ' + this.emptyCond('userCheckInDetailID')
    return this.dbQuery(removeQuery, []).then(() =>
      this.dbQuery(removeOpenCheckinQuery, []),
    )
  }

  /**
   * Remove evacuation row after online guest checkout (mirrors offline insertCheckOutDetails_Guest DELETE).
   */
  removeEvacuationForGuestAtEntity = (
    firstAndLastName: string,
    entity: DeviceEntityDetail,
  ) => {
    if (!firstAndLastName?.trim() || !entity) {
      return Promise.resolve(null)
    }
    const base = this.appendEntityCondition(entity)
    if (!base) {
      return Promise.resolve(null)
    }
    const removeQuery =
      'DELETE FROM DeviceEvacuations WHERE ' +
      base +
      ' AND firstAndLastName = "' +
      firstAndLastName +
      '"'
    return this.dbQuery(removeQuery, [])
  }

  /**
   * Add evacuation row after successful online company-user check-in (mirrors insertCheckinDetails evacuation insert).
   */
  upsertEvacuationAfterOnlineCompanyUserCheckIn = (params: {
    userId: string
    firstName: string
    middleName?: string
    lastName: string
    userDetailPhoto?: string
    userPhoto?: string
    userPhotoImageVideoFileId?: number
    locationID: number
    projectID: number
    inventoryItemID: number
  }) => {
    const firstAndLastName = (
      (params.firstName || '') +
      ' ' +
      (params.middleName ? params.middleName + ' ' : '') +
      (params.lastName || '')
    ).trim()
    const evacuationData = {
      firstAndLastName,
      firstName: params.firstName || '',
      inventoryItemID: params.inventoryItemID || 0,
      lastName: params.lastName || '',
      locationID: params.locationID || 0,
      projectID: params.projectID || 0,
      userDetailPhoto: params.userDetailPhoto || '',
      userId: params.userId || StaticDataService.userDefaultGuid,
      userPhoto: params.userPhoto || '',
      userPhotoImageVideoFileId: params.userPhotoImageVideoFileId || 0,
    }
    const evacCondition: any = {}
    if (evacuationData.inventoryItemID) {
      evacCondition.inventoryItemID = evacuationData.inventoryItemID
    } else if (evacuationData.locationID) {
      evacCondition.locationID = evacuationData.locationID
    } else if (evacuationData.projectID) {
      evacCondition.projectID = evacuationData.projectID
    }
    if (evacuationData.firstAndLastName) {
      evacCondition.firstAndLastName = evacuationData.firstAndLastName
    }
    return this.insertData('DeviceEvacuations', evacuationData, evacCondition)
  }

  insertCheckinDetailAfterOnlineCheckIn = (params: {
    userId: string
    firstName: string
    middleName?: string
    lastName: string
    locationID: number
    projectID: number
    inventoryItemID: number
    entityName: string
    companyID: number
    checkInDate: string
  }) => {
    const firstAndLastName = (
      (params.firstName || '') +
      ' ' +
      (params.middleName ? params.middleName + ' ' : '') +
      (params.lastName || '')
    ).trim()
    const data: any = {
      userId: params.userId,
      locationID: params.locationID || 0,
      projectID: params.projectID || 0,
      inventoryItemID: params.inventoryItemID || 0,
      entityName: params.entityName || '',
      checkInDate: params.checkInDate,
      checkOutDate: '',
      isSimultaneousCheckIn: true,
      companyID: params.companyID || 0,
      firstName: params.firstName || '',
      lastName: params.lastName || '',
      firstAndLastName,
    }
    const condition: any = { userId: params.userId }
    if (params.inventoryItemID) {
      condition.inventoryItemID = params.inventoryItemID
    } else if (params.locationID) {
      condition.locationID = params.locationID
    } else if (params.projectID) {
      condition.projectID = params.projectID
    }
    return this.insertData('DeviceUserCheckinDetails', data, condition)
  }

  insertGuestCheckinDetailAfterOnlineCheckIn = (params: {
    guestPhone: string | number
    guestFirsName: string
    guestMiddleName?: string
    guestLastName: string
    locationID: number
    projectID: number
    inventoryItemID: number
    entityName: string
    companyID: number
    checkInDate: string
  }) => {
    const firstAndLastName = (
      (params.guestFirsName || '') +
      ' ' +
      (params.guestMiddleName ? params.guestMiddleName + ' ' : '') +
      (params.guestLastName || '')
    ).trim()
    const data: any = {
      guestPhone: params.guestPhone,
      locationID: params.locationID || 0,
      projectID: params.projectID || 0,
      inventoryItemID: params.inventoryItemID || 0,
      entityName: params.entityName || '',
      checkInDate: params.checkInDate,
      checkOutDate: '',
      isSimultaneousCheckIn: true,
      companyID: params.companyID || 0,
      guestFirsName: params.guestFirsName || '',
      guestLastName: params.guestLastName || '',
      guestMiddleName: params.guestMiddleName || '',
      firstAndLastName,
    }
    const condition: any = { guestPhone: params.guestPhone }
    if (params.inventoryItemID) {
      condition.inventoryItemID = params.inventoryItemID
    } else if (params.locationID) {
      condition.locationID = params.locationID
    } else if (params.projectID) {
      condition.projectID = params.projectID
    }
    return this.insertData('DeviceGuestUserCheckinDetails', data, condition)
  }

  insertGuestUserAfterOnlineCheckIn = (params: {
    guestPhone: string | number
    guestFirsName: string
    guestMiddleName?: string
    guestLastName: string
    guestPhoto?: string
  }) => {
    const data: any = {
      guestPhone: params.guestPhone,
      guestFirsName: params.guestFirsName || '',
      guestMiddleName: params.guestMiddleName || '',
      guestLastName: params.guestLastName || '',
      guestPhoto: params.guestPhoto || '',
    }
    return this.insertData('DeviceGuestUsers', data, { guestPhone: params.guestPhone })
  }

  /**
   * Add evacuation row after successful online guest check-in (mirrors insertGuestCheckinDetails evacuation insert).
   */
  upsertEvacuationAfterOnlineGuestCheckIn = (params: {
    guestFirsName: string
    guestMiddleName?: string
    guestLastName: string
    guestPhotoImageVideoFileId?: number
    locationID: number
    projectID: number
    inventoryItemID: number
  }) => {
    const firstAndLastName = (
      (params.guestFirsName || '') +
      ' ' +
      (params.guestMiddleName ? params.guestMiddleName + ' ' : '') +
      (params.guestLastName || '')
    ).trim()
    const evacuationData = {
      firstAndLastName,
      firstName: params.guestFirsName || '',
      inventoryItemID: params.inventoryItemID || 0,
      lastName: params.guestLastName || '',
      locationID: params.locationID || 0,
      projectID: params.projectID || 0,
      userDetailPhoto: '',
      userPhoto: '',
      userPhotoImageVideoFileId: params.guestPhotoImageVideoFileId || 0,
    }
    const evacCondition: any = {}
    if (evacuationData.inventoryItemID) {
      evacCondition.inventoryItemID = evacuationData.inventoryItemID
    } else if (evacuationData.locationID) {
      evacCondition.locationID = evacuationData.locationID
    } else if (evacuationData.projectID) {
      evacCondition.projectID = evacuationData.projectID
    }
    if (evacuationData.firstAndLastName) {
      evacCondition.firstAndLastName = evacuationData.firstAndLastName
    }
    return this.insertData('DeviceEvacuations', evacuationData, evacCondition)
      .then((r: any) => {
        console.log('[EVAC] evacuation:insert | name:', firstAndLastName, '| locationID:', evacuationData.locationID, '| rowsAffected:', r?.rowsAffected)
        return r
      })
      .catch((e) => {
        console.error('[EVAC] evacuation:insert ERROR | name:', firstAndLastName, '|', e)
        throw e
      })
  }

  /**
   * Execute database operations in a transaction
   * Wraps operations with BEGIN TRANSACTION, COMMIT, and ROLLBACK
   */
  executeInTransaction = async (operations: () => Promise<void>): Promise<void> => {
    try {
      // Begin transaction
      await this.dbQuery('BEGIN TRANSACTION', []);
      console.log('🔄 [TRANSACTION] Transaction started');
      
      try {
        // Execute all operations
        await operations();
        
        // Commit transaction
        await this.dbQuery('COMMIT', []);
        console.log('✅ [TRANSACTION] Transaction committed successfully');
      } catch (operationError) {
        // Rollback on any error
        console.error('❌ [TRANSACTION] Error during transaction, rolling back:', operationError);
        try {
          await this.dbQuery('ROLLBACK', []);
          console.log('🔄 [TRANSACTION] Transaction rolled back');
        } catch (rollbackError) {
          console.error('❌ [TRANSACTION] Error during rollback:', rollbackError);
        }
        throw operationError; // Re-throw the original error
      }
    } catch (error) {
      console.error('❌ [TRANSACTION] Transaction failed:', error);
      throw error;
    }
  }

  emptyAllTables = async (callBack) => {
    try {
      let emptiedCount = 0
      StaticDataService.offlineTables.map((data) => {
        if (data.table_name) {
          this.emptyTable(data.table_name)
            .then(() => {
              emptiedCount++
              if (emptiedCount === StaticDataService.offlineTables.length) {
                callBack && callBack()
              }
            })
            .catch(() => {
              emptiedCount++
              if (emptiedCount === StaticDataService.offlineTables.length) {
                callBack && callBack()
              }
            })
        }
      })
    } catch (error) {}
  }

  insertOfflineData = async (
    offlineData: DeviceOfflineDetailViewModels,
    callBack,
  ) => {
    // deviceDetailData
    const deviceDetailData = offlineData.deviceDetailData
    if (deviceDetailData) {
      const condition: any = {
        companyID: deviceDetailData?.companyID,
        deviceID: deviceDetailData?.deviceID,
      }
      await this.insertData('DeviceDetails', deviceDetailData, condition)

      callBack && callBack()
      console.log('DeviceDetails Inserted')
      this.offlineDeviceDetailData = deviceDetailData
      if (deviceDetailData.isOfflineEnabled !== undefined) {
        localStorage.setItem(
          EnumService.LocalStorageKeys.OFFLINE_ENABLED_KEY,
          String(deviceDetailData.isOfflineEnabled)
        )
      }
    }

    // deviceEntityData
    const deviceEntityData = offlineData.deviceEntityData
    if (deviceEntityData) {
      for (let index = 0; index < deviceEntityData.length; index++) {
        const value: DeviceEntityData = deviceEntityData[index]
        const condition: any = {
          deviceEntityID: value.deviceEntityID,
          deviceID: value.deviceID,
        }

        if (value.locationID) {
          condition['locationID'] = value.locationID
        } else if (value.projectID) {
          condition['projectID'] = value.projectID
        } else if (value.inventoryItemID) {
          condition['inventoryItemID'] = value.inventoryItemID
        }
        await this.insertData('DeviceEntities', value, condition)
      }
      callBack && callBack()
      console.log('DeviceEntities Inserted')
    }

    // deviceUserList
    const deviceUserList = offlineData.deviceUserList
    if (deviceUserList) {
      for (let index = 0; index < deviceUserList.length; index++) {
        const value: DeviceUserDetail = deviceUserList[index]
        const condition: any = {
          userId: value.userId,
          companyID: value?.companyID,
        }
        await this.insertData('DeviceUsers', value, condition)
      }
      callBack && callBack()
      console.log('DeviceUsers Inserted')
    }

    // deviceUserQualificationList
    const deviceUserQualificationList = offlineData.deviceUserQualificationList
    if (deviceUserQualificationList) {
      for (let index = 0; index < deviceUserQualificationList.length; index++) {
        const value: DeviceUserQualificationDetail =
          deviceUserQualificationList[index]
        const condition: any = {
          qualificationID: value.qualificationID,
          userId: value.userId,
        }
        await this.insertData('DeviceUserQualifications', value, condition)
      }
      callBack && callBack()
      console.log('DeviceUserQualifications Inserted')
    }

    // deviceGuestUserList
    const deviceGuestUserList = offlineData.deviceGuestUserList
    if (deviceGuestUserList) {
      for (let index = 0; index < deviceGuestUserList.length; index++) {
        const value: DeviceGuestUserDetail = deviceGuestUserList[index]
        const condition: any = { guestPhone: value.guestPhone }
        await this.insertData('DeviceGuestUsers', value, condition)
      }
      callBack && callBack()
      console.log('DeviceGuestUsers Inserted')
    }

    // deviceAvailableDocumentList
    const deviceAvailableDocumentList = offlineData.deviceAvailableDocumentList
    if (deviceAvailableDocumentList) {
      console.log(`💾 [INSERT] Inserting ${deviceAvailableDocumentList.length} documents into DeviceAvailableDocuments`);
      for (let index = 0; index < deviceAvailableDocumentList.length; index++) {
        const value: DeviceAvailableDocumentDetail =
          deviceAvailableDocumentList[index]
        
        console.log(`💾 [INSERT] Document ${index + 1}/${deviceAvailableDocumentList.length}:`, {
          documentID: value.documentID,
          documentVersionID: value.documentVersionID,
          documentVersionNo: value.documentVersionNo,
          folderID: value.folderID,
          parentFolderID: value.parentFolderID,
          locationID: value.locationID,
          projectID: value.projectID,
          inventoryItemID: value.inventoryItemID,
          documentTitle: value.documentTitle
        });
        
        const condition: any = {}
        if (value.documentID) {
          condition['documentID'] = value.documentID
          condition['documentVersionID'] = value.documentVersionID
          // Fix: parentFolderID should be from value.parentFolderID, not documentVersionID
          condition['parentFolderID'] = value.parentFolderID ?? 0
        } else if (value.folderID) {
          condition['folderID'] = value.folderID
          condition['parentFolderID'] = value.parentFolderID ?? value.folderID ?? 0
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        
        console.log(`💾 [INSERT] Insert condition:`, condition);
        try {
          await this.insertData('DeviceAvailableDocuments', value, condition);
          
          // Verify the document was inserted with the exact condition we used
          const verifyQuery = `SELECT documentID, documentVersionID, documentTitle, parentFolderID, locationID, projectID, inventoryItemID FROM DeviceAvailableDocuments WHERE documentID = ${value.documentID} AND documentVersionID = ${value.documentVersionID} AND parentFolderID = ${value.parentFolderID ?? 0} AND locationID = ${value.locationID}`;
          const verifyResult: any = await this.dbQuery(verifyQuery, []);
          if (verifyResult?.rows?.length > 0) {
            const insertedDocs = this.convertToArray(verifyResult.rows);
            const docsList = insertedDocs.map((d: any) => ({
              documentID: d.documentID,
              documentVersionID: d.documentVersionID,
              documentTitle: d.documentTitle,
              parentFolderID: d.parentFolderID,
              locationID: d.locationID,
              projectID: d.projectID,
              inventoryItemID: d.inventoryItemID
            }));
            console.log(`✅ [INSERT] Verified document inserted with exact condition:`, docsList);
            // Also verify it matches the offline query condition
            // If parentFolderID is 0, check root level query; otherwise check folder query
            const finalParentFolderID = value.parentFolderID ?? 0;
            let offlineQueryTest: string;
            if (finalParentFolderID === 0 || finalParentFolderID === null) {
              // Root level documents
              offlineQueryTest = `SELECT documentID, documentVersionID, documentTitle, parentFolderID, locationID FROM DeviceAvailableDocuments WHERE locationID = ${value.locationID} AND (parentFolderID is NULL OR parentFolderID = 0 OR parentFolderID = '')`;
            } else {
              // Documents in a folder
              offlineQueryTest = `SELECT documentID, documentVersionID, documentTitle, parentFolderID, locationID FROM DeviceAvailableDocuments WHERE (locationID = ${value.locationID} OR ( (projectID is NULL OR projectID = 0 OR projectID = '') AND (locationID is NULL OR locationID = 0 OR locationID = '') AND (inventoryItemID is NULL OR inventoryItemID = 0 OR inventoryItemID = '') )) AND parentFolderID = ${finalParentFolderID}`;
            }
            
            const offlineQueryResult: any = await this.dbQuery(offlineQueryTest, []);
            if (offlineQueryResult?.rows?.length > 0) {
              const offlineDocs = this.convertToArray(offlineQueryResult.rows);
              const foundDoc = offlineDocs.find((d: any) => d.documentID === value.documentID && d.documentVersionID === value.documentVersionID);
              if (foundDoc) {
                console.log(`✅ [INSERT] Document will be found by offline query (parentFolderID: ${finalParentFolderID})!`, {
                  documentID: foundDoc.documentID,
                  documentVersionID: foundDoc.documentVersionID,
                  parentFolderID: foundDoc.parentFolderID,
                  locationID: foundDoc.locationID
                });
              } else {
                console.warn(`⚠️ [INSERT] Document inserted but NOT found by offline query!`, {
                  inserted: docsList[0],
                  queryUsed: offlineQueryTest,
                  offlineQueryResults: offlineDocs.length,
                  offlineDocs: offlineDocs.map((d: any) => ({
                    documentID: d.documentID,
                    documentVersionID: d.documentVersionID,
                    parentFolderID: d.parentFolderID,
                    locationID: d.locationID
                  }))
                });
              }
            } else {
              console.warn(`⚠️ [INSERT] Offline query returned no results for locationID ${value.locationID}, parentFolderID ${finalParentFolderID}`);
            }
          } else {
            // Check if document exists with different parentFolderID or locationID
            const checkAllQuery = `SELECT documentID, documentVersionID, documentTitle, parentFolderID, locationID, projectID, inventoryItemID FROM DeviceAvailableDocuments WHERE documentID = ${value.documentID} AND documentVersionID = ${value.documentVersionID}`;
            const checkAllResult: any = await this.dbQuery(checkAllQuery, []);
            if (checkAllResult?.rows?.length > 0) {
              const existingDocs = this.convertToArray(checkAllResult.rows);
              console.warn(`⚠️ [INSERT] Document exists but with different condition! Expected: parentFolderID=${value.parentFolderID ?? 0}, locationID=${value.locationID}. Found:`, existingDocs.map((d: any) => ({
                documentID: d.documentID,
                documentVersionID: d.documentVersionID,
                documentTitle: d.documentTitle,
                parentFolderID: d.parentFolderID,
                locationID: d.locationID,
                projectID: d.projectID,
                inventoryItemID: d.inventoryItemID
              })));
            } else {
              console.warn(`⚠️ [INSERT] Document was not found after insertion! documentID: ${value.documentID}, documentVersionID: ${value.documentVersionID}`);
            }
          }
        } catch (insertError) {
          console.error(`❌ [INSERT] Error inserting document ${value.documentID}:`, insertError);
          throw insertError;
        }
        
        // Download PDF file if documentDownloadUrl is available (only for actual documents, not folders)
        const documentDownloadUrl = (value as any).documentDownloadUrl;
        if (documentDownloadUrl && value.documentFileName && value.documentID && value.documentID !== 0) {
          // Debug: Log the URL to verify it has query parameters
          console.log(`📥 [DOWNLOAD] Document ${value.documentID} - documentDownloadUrl:`, documentDownloadUrl);
          console.log(`📥 [DOWNLOAD] Document ${value.documentID} - Has query params:`, documentDownloadUrl.includes('?'));
          const forceDownload = this.documentsToReDownload.has(value.documentID);
          if (forceDownload) {
            console.log(`📥 [DOWNLOAD] Document ${value.documentID} marked for forced re-download`);
          }
          try {
            await this.downloadDocumentFile(documentDownloadUrl, value.documentFileName, forceDownload);
          } catch (downloadError) {
            // Log error but don't fail the sync if download fails
            console.error(`⚠️ [DOWNLOAD] Failed to download document ${value.documentFileName}:`, downloadError);
          }
        } else if (value.documentID && value.documentID !== 0 && value.documentFileName) {
          // Debug: Log when documentDownloadUrl is missing
          console.warn(`⚠️ [DOWNLOAD] Document ${value.documentID} (${value.documentFileName}) has no documentDownloadUrl - cannot download for offline access`);
        }

      }
      callBack && callBack()
      console.log('DeviceAvailableDocuments Inserted')
    } else {
      console.warn('⚠️ [INSERT] deviceAvailableDocumentList is empty or undefined');
    }

    // deviceArchivedDocumentList
    const deviceArchivedDocumentList = offlineData.deviceArchivedDocumentList
    if (deviceArchivedDocumentList) {
      for (let index = 0; index < deviceArchivedDocumentList.length; index++) {
        const value: DeviceArchivedDocumentDetail =
          deviceArchivedDocumentList[index]
        const condition: any = {
          documentID: value.documentID,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceArchivedDocuments', value, condition)
      }
      callBack && callBack()
      console.log('DeviceArchivedDocuments Inserted')
    }

    // deviceAvailableFormList
    const deviceAvailableFormList = offlineData.deviceAvailableFormList
    if (deviceAvailableFormList) {
      for (let index = 0; index < deviceAvailableFormList.length; index++) {
        const value: DeviceAvailableFormDetail = deviceAvailableFormList[index]

        const condition: any = {}
        if (value.formID) {
          condition['formID'] = value.formID
          condition['formVersionID'] = value.formVersionID
        } else if (value.formFolderID) {
          condition['formFolderID'] = value.formFolderID
        }

        if (value.parentFormFolderID) {
          condition['parentFormFolderID'] = value.parentFormFolderID
        }

        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceAvailableForms', value, condition)
      }
      callBack && callBack()
      console.log('DeviceAvailableForms Inserted')
    }

    // deviceArchivedFormList
    const deviceArchivedFormList = offlineData.deviceArchivedFormList
    if (deviceArchivedFormList) {
      for (let index = 0; index < deviceArchivedFormList.length; index++) {
        const value: DeviceArchivedFormDetail = deviceArchivedFormList[index]
        const condition: any = {
          documentID: value.documentID,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceArchivedForms', value, condition)
      }
      callBack && callBack()
      console.log('DeviceArchivedForms Inserted')
    }

    // deviceAvailableWorkPermitList
    const deviceAvailableWorkPermitList =
      offlineData.deviceAvailableWorkPermitList
    if (deviceAvailableWorkPermitList) {
      for (
        let index = 0;
        index < deviceAvailableWorkPermitList.length;
        index++
      ) {
        const value: DeviceAvailableWorkPermitDetail =
          deviceAvailableWorkPermitList[index]
        const condition: any = {
          formID: value.formID,
          formVersionID: value.formVersionID,
          formVersionNo: value.formVersionNo,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceAvailableWorkPermits', value, condition)
      }
      callBack && callBack()
      console.log('DeviceAvailableWorkPermits Inserted')
    }

    // deviceLiveWorkPermitList
    const deviceLiveWorkPermitList = offlineData.deviceLiveWorkPermitList
    if (deviceLiveWorkPermitList) {
      for (let index = 0; index < deviceLiveWorkPermitList.length; index++) {
        const value: DeviceLiveWorkPermitDetail =
          deviceLiveWorkPermitList[index]
        const condition: any = {
          userWorkPermitId: value.userWorkPermitId,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceLiveWorkPermits', value, condition)
      }
      callBack && callBack()
      console.log('DeviceLiveWorkPermits Inserted')
    }

    // deviceArchivedWorkPermitList
    const deviceArchivedWorkPermitList =
      offlineData.deviceArchivedWorkPermitList
    if (deviceArchivedWorkPermitList) {
      for (
        let index = 0;
        index < deviceArchivedWorkPermitList.length;
        index++
      ) {
        const value: DeviceArchivedWorkPermitDetail =
          deviceArchivedWorkPermitList[index]
        const condition: any = {
          userWorkPermitId: value.userWorkPermitId,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceArchivedWorkPermits', value, condition)
      }
      callBack && callBack()
      console.log('DeviceArchivedWorkPermits Inserted')
    }

    // deviceFormDetailsList
    const deviceFormDetailsList = offlineData.deviceFormDetailsList
    if (deviceFormDetailsList) {
      console.log(`💾 [INSERT] Inserting ${deviceFormDetailsList.length} form details into DeviceFormDetails`);
      for (let index = 0; index < deviceFormDetailsList.length; index++) {
        const value: DeviceFormDetail = deviceFormDetailsList[index]
        
        console.log(`💾 [INSERT] Form detail ${index + 1}/${deviceFormDetailsList.length}:`, {
          formID: value.formID,
          formVersionID: value.formVersionID,
          formVersionNo: value.formVersionNo,
          parentFormFolderID: value.parentFormFolderID,
          locationID: value.locationID,
          projectID: value.projectID,
          inventoryItemID: value.inventoryItemID
        });

        const condition: any = {
          formID: value.formID,
          formVersionID: value.formVersionID,
          formVersionNo: value.formVersionNo,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        
        console.log(`💾 [INSERT] Insert condition:`, condition);
        await this.insertData('DeviceFormDetails', value, condition)
      }
      callBack && callBack()
      console.log('DeviceFormDetails Inserted')
    } else {
      console.warn('⚠️ [INSERT] deviceFormDetailsList is empty or undefined');
    }

    // deviceFormAttachmentList
    const deviceFormAttachmentList = offlineData.deviceFormAttachmentList
    if (deviceFormAttachmentList) {
      for (let index = 0; index < deviceFormAttachmentList.length; index++) {
        const value: DeviceFormAttachmentDetail =
          deviceFormAttachmentList[index]

        const condition: any = {
          formID: value.formID,
          documentID: value.documentID,
        }

        await this.insertData('DeviceFormAttachments', value, condition)
      }
      callBack && callBack()
      console.log('DeviceFormAttachments Inserted')
      await this.downloadFormCoverAttachments(deviceFormAttachmentList)
    }

    // deviceEvacuationList
    const deviceEvacuationList = offlineData.deviceEvacuationList
    if (deviceEvacuationList) {
      await this.emptyTable('DeviceEvacuations')
      for (let index = 0; index < deviceEvacuationList.length; index++) {
        const value: DeviceEvacuationDetail = deviceEvacuationList[index]

        const condition: any = {
          firstAndLastName: value.firstAndLastName,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceEvacuations', value, condition)
      }
      callBack && callBack()
      console.log('DeviceEvacuations Inserted')
    }

    // deviceUserCheckInQualificationList
    const deviceUserCheckInQualificationList =
      offlineData.deviceUserCheckInQualificationList
    if (deviceUserCheckInQualificationList) {
      for (
        let index = 0;
        index < deviceUserCheckInQualificationList.length;
        index++
      ) {
        const value: DeviceUserCheckInQualificationDetail =
          deviceUserCheckInQualificationList[index]

        const condition: any = {
          qualificationID: value.qualificationID,
        }
        if (value.locationID) {
          condition['locationID'] = value.locationID
        } else if (value.projectID) {
          condition['projectID'] = value.projectID
        } else if (value.inventoryItemID) {
          condition['inventoryItemID'] = value.inventoryItemID
        }
        await this.insertData(
          'DeviceUserCheckInQualifications',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceUserCheckInQualifications Inserted')
    }

    // deviceLocationList
    const deviceLocationList = offlineData.deviceLocationList
    if (deviceLocationList) {
      for (let index = 0; index < deviceLocationList.length; index++) {
        const value: DeviceLocationDetail = deviceLocationList[index]
        const condition: any = {
          companyID: value?.companyID,
          locationID: value?.locationID,
        }
        await this.insertData('DeviceLocations', value, condition)
      }
      callBack && callBack()
      console.log('DeviceLocations Inserted')
    }

    // deviceProjectList
    const deviceProjectList = offlineData.deviceProjectList
    if (deviceProjectList) {
      for (let index = 0; index < deviceProjectList.length; index++) {
        const value: DeviceProjectDetail = deviceProjectList[index]
        const condition: any = {
          companyID: value?.companyID,
          projectID: value?.projectID,
        }
        await this.insertData('DeviceProjects', value, condition)
      }
      callBack && callBack()
      console.log('DeviceProjects Inserted')
    }

    // deviceInventoryItemList
    const deviceInventoryItemList = offlineData.deviceInventoryItemList
    if (deviceInventoryItemList) {
      for (let index = 0; index < deviceInventoryItemList.length; index++) {
        const value: DeviceInventoryItemDetail = deviceInventoryItemList[index]
        const condition: any = {
          companyID: value?.companyID,
          inventoryItemID: value?.inventoryItemID,
        }
        await this.insertData('DeviceInventoryItems', value, condition)
      }
      callBack && callBack()
      console.log('DeviceInventoryItems Inserted')
    }

    // deviceUserCheckinDetailList
    const deviceUserCheckinDetailList = offlineData.deviceUserCheckinDetailList
    if (deviceUserCheckinDetailList) {
      for (let index = 0; index < deviceUserCheckinDetailList.length; index++) {
        const value: DeviceUserCheckinDetail =
          deviceUserCheckinDetailList[index]
        const condition: any = {
          userCheckInDetailID: value.userCheckInDetailID,
          userId: value.userId,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceUserCheckinDetails', value, condition)
      }
      callBack && callBack()
      console.log('DeviceUserCheckinDetails Inserted')
    }

    // deviceCheckInInductionList
    const deviceCheckInInductionList = offlineData.deviceCheckInInductionList
    if (deviceCheckInInductionList) {
      for (let index = 0; index < deviceCheckInInductionList.length; index++) {
        const value: DeviceCheckInInductionDetail =
          deviceCheckInInductionList[index]
        const condition: any = {
          checkInInductionID: value.checkInInductionID,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceCheckInInductions', value, condition)
      }
      callBack && callBack()
      console.log('DeviceCheckInInductions Inserted')
    }

    // deviceCheckInInductionItemList
    const deviceCheckInInductionItemList =
      offlineData.deviceCheckInInductionItemList
    if (deviceCheckInInductionItemList) {
      for (
        let index = 0;
        index < deviceCheckInInductionItemList.length;
        index++
      ) {
        const value: DeviceCheckInInductionItemDetail =
          deviceCheckInInductionItemList[index]
        const condition: any = {
          checkInInductionID: value.checkInInductionID,
          checkInInductionItemID: value.checkInInductionItemID,
          documentID: value.documentID,
          formID: value.formID,
        }
        await this.insertData('DeviceCheckInInductionItems', value, condition)
        // Download image/video file if this induction item has a file
        if (value.documentFileName) {
          try {
            const apiService = this.injector.get(ApiService);
            const inductionFileUrl = await apiService.getDocumentDirectoryFilePath(value.documentFileName).toPromise();
            if (inductionFileUrl) {
              console.log(`📥 [INDUCTION] Downloading induction file: ${value.documentFileName}`);
              await this.downloadDocumentFile(inductionFileUrl, value.documentFileName, false);
            }
          } catch (err) {
            console.warn(`⚠️ [INDUCTION] Failed to download induction file ${value.documentFileName}:`, err);
          }
        }
      }
      callBack && callBack()
      console.log('DeviceCheckInInductionItems Inserted')
    }

    // deviceGuestUserCheckinDetailList
    const deviceGuestUserCheckinDetailList =
      offlineData.deviceGuestUserCheckinDetailList
    if (deviceGuestUserCheckinDetailList) {
      for (
        let index = 0;
        index < deviceGuestUserCheckinDetailList.length;
        index++
      ) {
        const value: DeviceGuestUserCheckinDetail =
          deviceGuestUserCheckinDetailList[index]
        const condition: any = {
          userCheckInDetailID: value.userCheckInDetailID,
          userId: value.userId,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceGuestUserCheckinDetails', value, condition)
      }
      callBack && callBack()
      console.log('DeviceGuestUserCheckinDetails Inserted')
    }

    // deviceCheckInGuestInductionList
    const deviceCheckInGuestInductionList =
      offlineData.deviceCheckInGuestInductionList
    if (deviceCheckInGuestInductionList) {
      for (
        let index = 0;
        index < deviceCheckInGuestInductionList.length;
        index++
      ) {
        const value: DeviceCheckInGuestInductionDetail =
          deviceCheckInGuestInductionList[index]
        const condition: any = {
          checkInInductionGuestID: value.checkInInductionGuestID,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }
        await this.insertData('DeviceCheckInGuestInductions', value, condition)
      }
      callBack && callBack()
      console.log('DeviceCheckInGuestInductions Inserted')
    }

    // deviceCheckInGuestInductionItemList
    const deviceCheckInGuestInductionItemList =
      offlineData.deviceCheckInGuestInductionItemList
    if (deviceCheckInGuestInductionItemList) {
      for (
        let index = 0;
        index < deviceCheckInGuestInductionItemList.length;
        index++
      ) {
        const value: DeviceCheckInGuestInductionItemDetail =
          deviceCheckInGuestInductionItemList[index]

        const condition: any = {
          checkInInductionGuestID: value.checkInInductionGuestID,
          checkInInductionGuestItemID: value.checkInInductionGuestItemID,
          documentID: value.documentID,
          formID: value.formID,
        }

        await this.insertData(
          'DeviceCheckInGuestInductionItems',
          value,
          condition,
        )
        // Download image/video file if this guest induction item has a file
        if (value.documentFileName) {
          try {
            const apiService = this.injector.get(ApiService);
            const guestInductionFileUrl = await apiService.getDocumentDirectoryFilePath(value.documentFileName).toPromise();
            if (guestInductionFileUrl) {
              console.log(`📥 [INDUCTION] Downloading guest induction file: ${value.documentFileName}`);
              await this.downloadDocumentFile(guestInductionFileUrl, value.documentFileName, false);
            }
          } catch (err) {
            console.warn(`⚠️ [INDUCTION] Failed to download guest induction file ${value.documentFileName}:`, err);
          }
        }
      }
      callBack && callBack()
      console.log('DeviceCheckInGuestInductionItems Inserted')
    }

    // deviceUserLastCheckinDetailList
    const deviceUserLastCheckinDetailList =
      offlineData.deviceUserLastCheckinDetailList
    if (deviceUserLastCheckinDetailList) {
      for (
        let index = 0;
        index < deviceUserLastCheckinDetailList.length;
        index++
      ) {
        const value: DeviceUserLastCheckinDetail =
          deviceUserLastCheckinDetailList[index]

        const condition: any = {
          userCheckInDetailID: value.userCheckInDetailID,
          userId: value.userId,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }

        await this.insertData(
          'DeviceUserLastCheckinDetailList',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceUserLastCheckinDetailList Inserted')
    }

    // deviceGuestUserLastCheckinDetailList
    const deviceGuestUserLastCheckinDetailList =
      offlineData.deviceGuestUserLastCheckinDetailList
    if (deviceGuestUserLastCheckinDetailList) {
      for (
        let index = 0;
        index < deviceGuestUserLastCheckinDetailList.length;
        index++
      ) {
        const value: DeviceGuestUserLastCheckinDetail =
          deviceGuestUserLastCheckinDetailList[index]

        const condition: any = {
          userCheckInDetailID: value.userCheckInDetailID,
        }
        if (value.locationID > 0) {
          condition.locationID = value.locationID
        } else if (value.projectID > 0) {
          condition.projectID = value.projectID
        } else if (value.inventoryItemID > 0) {
          condition.inventoryItemID = value.inventoryItemID
        }

        await this.insertData(
          'DeviceGuestUserLastCheckinDetailList',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceGuestUserLastCheckinDetailList Inserted')
    }

    // deviceCompanyUserList
    const deviceCompanyUserList = offlineData.deviceCompanyUserList
    if (deviceCompanyUserList) {
      for (let index = 0; index < deviceCompanyUserList.length; index++) {
        const value: DeviceCompanyUserDetail = deviceCompanyUserList[index]
        const condition: any = {
          userId: value.userId,
        }
        await this.insertData('DeviceCompanyUsers', value, condition)
      }
      callBack && callBack()
      console.log('DeviceCompanyUsers Inserted')
    }

    // deviceCompanyUserGroupList
    const deviceCompanyUserGroupList = offlineData.deviceCompanyUserGroupList
    if (deviceCompanyUserGroupList) {
      for (let index = 0; index < deviceCompanyUserGroupList.length; index++) {
        const value: DeviceCompanyUserGroupDetail =
          deviceCompanyUserGroupList[index]
        const condition: any = {
          userGroupID: value.userGroupID,
        }
        await this.insertData('DeviceCompanyUserGroups', value, condition)
      }
      callBack && callBack()
      console.log('DeviceCompanyUserGroups Inserted')
    }

    // deviceHAVManufacturerList
    const deviceHAVManufacturerList = offlineData.deviceHAVManufacturerList
    if (deviceHAVManufacturerList) {
      for (let index = 0; index < deviceHAVManufacturerList.length; index++) {
        const value: DeviceHAVManufacturerDetail =
          deviceHAVManufacturerList[index]
        const condition: any = {
          companyID: value?.companyID,
          havManufacturerID: value?.havManufacturerID,
        }
        await this.insertData('DeviceHAVManufacturers', value, condition)
      }
      callBack && callBack()
      console.log('DeviceHAVManufacturers Inserted')
    }

    // deviceHAVTypeList
    const deviceHAVTypeList = offlineData.deviceHAVTypeList
    if (deviceHAVTypeList) {
      for (let index = 0; index < deviceHAVTypeList.length; index++) {
        const value: DeviceHAVTypeDetail = deviceHAVTypeList[index]
        const condition: any = {
          companyID: value?.companyID,
          havManufacturerID: value?.havManufacturerID,
          havTypeID: value?.havTypeID,
        }
        await this.insertData('DeviceHAVTypes', value, condition)
      }
      callBack && callBack()
      console.log('DeviceHAVTypes Inserted')
    }

    // deviceHAVModelList
    const deviceHAVModelList = offlineData.deviceHAVModelList
    if (deviceHAVModelList) {
      for (let index = 0; index < deviceHAVModelList.length; index++) {
        const value: DeviceHAVModelDetail = deviceHAVModelList[index]
        const condition: any = {
          companyID: value?.companyID,
          havManufacturerID: value?.havManufacturerID,
          havTypeID: value?.havTypeID,
          havModelID: value?.havModelID,
        }
        await this.insertData('DeviceHAVModels', value, condition)
      }
      callBack && callBack()
      console.log('DeviceHAVModels Inserted')
    }

    // deviceRiskItemList
    const deviceRiskItemList = offlineData.deviceRiskItemList
    if (deviceRiskItemList) {
      for (let index = 0; index < deviceRiskItemList.length; index++) {
        const value: DeviceRiskItemDetail = deviceRiskItemList[index]
        const condition: any = {
          companyID: value?.companyID,
          companyRiskItemID: value?.companyRiskItemID,
        }
        await this.insertData('DeviceRiskItems', value, condition)
      }
      callBack && callBack()
      console.log('DeviceRiskItems Inserted')
    }

    // deviceHazardItemList
    const deviceHazardItemList = offlineData.deviceHazardItemList
    if (deviceHazardItemList) {
      for (let index = 0; index < deviceHazardItemList.length; index++) {
        const value: DeviceHazardItemDetail = deviceHazardItemList[index]
        const condition: any = {
          companyID: value?.companyID,
          companyRiskItemID: value?.companyRiskItemID,
          companyHazardItemID: value?.companyHazardItemID,
        }
        await this.insertData('DeviceHazardItems', value, condition)
      }
      callBack && callBack()
      console.log('DeviceHazardItems Inserted')
    }

    const deviceIOSHHarmTypeList = offlineData.deviceIOSHHarmTypeList;
    console.log('=== IOSH DEBUG: Harm Types ===');
    console.log('Received data:', deviceIOSHHarmTypeList);
    console.log('Count:', deviceIOSHHarmTypeList?.length || 0);
    if (deviceIOSHHarmTypeList) {
      for (let index = 0; index < deviceIOSHHarmTypeList.length; index++) {
        const value: any = deviceIOSHHarmTypeList[index];
        const condition: any = {
          companyID: value?.companyID,
          companyIosHarmTypeID: value?.companyIosHarmTypeID,
        };
        await this.insertData('DeviceIOSHHarmTypes', value, condition);
      }
      callBack && callBack();
      console.log('DeviceIOSHHarmTypes Inserted - Total:', deviceIOSHHarmTypeList.length);
    }

    const deviceIOSHHazardCategoryList = offlineData.deviceIOSHHazardCategoryList;
    if (deviceIOSHHazardCategoryList) {
      for (let index = 0; index < deviceIOSHHazardCategoryList.length; index++) {
        const value: any = deviceIOSHHazardCategoryList[index];
        const condition: any = {
          companyID: value?.companyID,
          companyIoshHazardCategoryID: value?.companyIoshHazardCategoryID,
        };
        await this.insertData('DeviceIOSHHazardCategories', value, condition);
      }
      callBack && callBack();
      console.log('DeviceIOSHHazardCategories Inserted');
    }

    const deviceIOSHHazardControlList = offlineData.deviceIOSHHazardControlList;
    if (deviceIOSHHazardControlList) {
      for (let index = 0; index < deviceIOSHHazardControlList.length; index++) {
        const value: any = deviceIOSHHazardControlList[index];
        const condition: any = {
          companyID: value?.companyID,
          companyIoshHazardControlID: value?.companyIoshHazardControlID,
          companyIoshHazardCategoryID: value?.companyIoshHazardCategoryID,
        };
        await this.insertData('DeviceIOSHHazardControls', value, condition);
      }
      callBack && callBack();
      console.log('DeviceIOSHHazardControls Inserted');
    }

    // deviceAnswerChoiceQrCodeEntityDataList
    const deviceAnswerChoiceQrCodeEntityDataList =
      offlineData.deviceAnswerChoiceQrCodeEntityDataList
    if (deviceAnswerChoiceQrCodeEntityDataList) {
      for (
        let index = 0;
        index < deviceAnswerChoiceQrCodeEntityDataList.length;
        index++
      ) {
        const value = deviceAnswerChoiceQrCodeEntityDataList[index]
        const condition: any = {
          entityID: value.entityID,
          entityType: value.entityType,
          qrCode: value.qrCode,
        }
        await this.insertData(
          'DeviceAnswerChoiceQrCodeEntities',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceAnswerChoiceQrCodeEntities Inserted')
    }

    // deviceLocationItemList
    const deviceLocationItemList = offlineData.deviceLocationItemList
    if (deviceLocationItemList) {
      for (let index = 0; index < deviceLocationItemList.length; index++) {
        const value: any = deviceLocationItemList[index]
        const condition: any = {
          locationID: value.locationID,
        }
        await this.insertData('DeviceLocationItems', value, condition)
      }
      callBack && callBack()
      console.log('DeviceLocationItems Inserted')
    }

    // deviceAccidentTypeList
    const deviceAccidentTypeList = offlineData.deviceAccidentTypeList
    if (deviceAccidentTypeList) {
      for (let index = 0; index < deviceAccidentTypeList.length; index++) {
        const value: any = deviceAccidentTypeList[index]
        const condition: any = {
          accidentTypeId: value.accidentTypeId,
        }
        await this.insertData('DeviceAccidentTypes', value, condition)
      }
      callBack && callBack()
      console.log('DeviceAccidentTypes Inserted')
    }

    // deviceAccidentClassificationList
    const deviceAccidentClassificationList =
      offlineData.deviceAccidentClassificationList
    if (deviceAccidentClassificationList) {
      for (
        let index = 0;
        index < deviceAccidentClassificationList.length;
        index++
      ) {
        const value: any = deviceAccidentClassificationList[index]
        const condition: any = {
          accidentClassificationId: value.accidentClassificationId,
        }
        await this.insertData('DeviceAccidentClassifications', value, condition)
      }
      callBack && callBack()
      console.log('DeviceAccidentClassifications Inserted')
    }

    // deviceRiskAssessmentProbabilityOptions
    const deviceRiskAssessmentProbabilityOptions =
      offlineData.deviceRiskAssessmentProbabilityOptionList
    if (deviceRiskAssessmentProbabilityOptions) {
      for (
        let index = 0;
        index < deviceRiskAssessmentProbabilityOptions.length;
        index++
      ) {
        const value: any = deviceRiskAssessmentProbabilityOptions[index]
        const condition: any = {
          riskAssessmentProbabilityOptionId:
            value.riskAssessmentProbabilityOptionId,
        }
        await this.insertData(
          'DeviceRiskAssessmentProbabilityOptions',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceRiskAssessmentProbabilityOptions Inserted')
    }

    // deviceUserTotalHAVExposureList
    const deviceUserTotalHAVExposureList =
      offlineData.deviceUserTotalHAVExposureList
    if (deviceUserTotalHAVExposureList) {
      for (
        let index = 0;
        index < deviceUserTotalHAVExposureList.length;
        index++
      ) {
        const value: any = deviceUserTotalHAVExposureList[index]
        await this.insertData('DeviceUserTotalHAVExposures', value)
      }
      callBack && callBack()
      console.log('DeviceUserTotalHAVExposures Inserted')
    }

    // deviceRiskAssessmentSeverityOptions
    const deviceRiskAssessmentSeverityOptions =
      offlineData.deviceRiskAssessmentSeverityOptionList
    if (deviceRiskAssessmentSeverityOptions) {
      for (
        let index = 0;
        index < deviceRiskAssessmentSeverityOptions.length;
        index++
      ) {
        const value: any = deviceRiskAssessmentSeverityOptions[index]
        const condition: any = {
          riskAssessmentSeverityOptionId: value.riskAssessmentSeverityOptionId,
        }
        await this.insertData(
          'DeviceRiskAssessmentSeverityOptions',
          value,
          condition,
        )
      }
      callBack && callBack()
      console.log('DeviceRiskAssessmentSeverityOptions Inserted')
    }

    // deviceFormBuilderDetailsList
    const deviceFormBuilderDetailsList =
      offlineData.deviceFormBuilderDetailsList
    if (deviceFormBuilderDetailsList) {
      for (
        let index = 0;
        index < deviceFormBuilderDetailsList.length;
        index++
      ) {
        const value: DeviceFormBuilderDetail =
          deviceFormBuilderDetailsList[index]
        const condition: any = {
          formId: value.formId,
          formVersionNo: value.formVersionNo,
          formVersionId: value.formVersionId,
        }
        await this.insertData('DeviceFormBuilderDetails', value, condition)
      }
      callBack && callBack()
      console.log('deviceFormBuilderDetailsList Inserted')
      await this.downloadFormBuilderQuestionAttachments(
        deviceFormBuilderDetailsList
      )
    }

    callBack && callBack(true)
  }

  private collectFormBuilderAttachmentFiles(formBuilder: any): Array<{
    fileName: string
    folderName?: string
    subfolder: 'document' | 'images'
    downloadUrl?: string
  }> {
    const files = new Map<
      string,
      {
        fileName: string
        folderName?: string
        subfolder: 'document' | 'images'
        downloadUrl?: string
      }
    >()

    const addFile = (
      fileName?: string,
      folderName?: string,
      subfolder: 'document' | 'images' = 'document',
      downloadUrl?: string
    ) => {
      if (!fileName) {
        return
      }
      const key = `${subfolder}:${fileName}`
      if (!files.has(key)) {
        files.set(key, { fileName, folderName, subfolder, downloadUrl })
      }
    }

    const addAttachment = (attachment: any) => {
      if (!attachment?.fileName) {
        return
      }
      addFile(
        attachment.fileName,
        attachment.folderName,
        'document',
        attachment.documentDownloadUrl
      )
    }

    let sections = formBuilder?.sections || []
    if (typeof sections === 'string') {
      try {
        sections = JSON.parse(sections)
      } catch (e) {
        sections = []
      }
    }

    for (const section of sections) {
      for (const question of section?.questions || []) {
        for (const attachment of question?.questionAttachments || []) {
          addAttachment(attachment)
        }
        addFile(question?.questionAttachmentIconPath, undefined, 'images')
      }
      for (const task of section?.tasks || []) {
        for (const attachment of task?.taskAttachments || []) {
          addAttachment(attachment)
        }
      }
    }

    return Array.from(files.values())
  }

  private async downloadFormBuilderQuestionAttachments(
    formBuilderDetailsList: DeviceFormBuilderDetail[]
  ): Promise<void> {
    if (UtilService.isWebApp() || environment.isFormPreview) {
      return
    }

    let apiService: ApiService
    try {
      apiService = this.injector.get(ApiService)
    } catch (e) {
      console.warn(
        '⚠️ [DOWNLOAD] ApiService unavailable — skipping question attachment downloads'
      )
      return
    }

    const attachmentFiles: Array<{
      fileName: string
      folderName?: string
      subfolder: 'document' | 'images'
      downloadUrl?: string
    }> = []
    for (const formBuilder of formBuilderDetailsList) {
      const files = this.collectFormBuilderAttachmentFiles(formBuilder)
      for (const file of files) {
        attachmentFiles.push(file)
      }
    }

    if (attachmentFiles.length === 0) {
      return
    }

    console.log(
      `📥 [DOWNLOAD] Downloading ${attachmentFiles.length} form question attachment file(s)`
    )

    for (const attachmentFile of attachmentFiles) {
      try {
        let downloadUrl = attachmentFile.downloadUrl
        if (!downloadUrl) {
          downloadUrl = await apiService
            .getDocumentDirectoryFilePath(
              attachmentFile.fileName,
              attachmentFile.folderName || ''
            )
            .toPromise()
        }

        if (!downloadUrl) {
          console.warn(
            `⚠️ [DOWNLOAD] No download URL for question attachment: ${attachmentFile.fileName}`
          )
          continue
        }

        await this.downloadDocumentFile(
          downloadUrl,
          attachmentFile.fileName,
          false,
          attachmentFile.subfolder
        )
      } catch (error) {
        console.error(
          `⚠️ [DOWNLOAD] Failed to download question attachment ${attachmentFile.fileName}:`,
          error
        )
      }
    }
  }

  private async downloadFormCoverAttachments(
    deviceFormAttachmentList: DeviceFormAttachmentDetail[]
  ): Promise<void> {
    if (UtilService.isWebApp() || environment.isFormPreview) {
      return
    }

    let apiService: ApiService
    try {
      apiService = this.injector.get(ApiService)
    } catch (e) {
      console.warn(
        '⚠️ [DOWNLOAD] ApiService unavailable — skipping form cover attachment downloads'
      )
      return
    }

    const downloadedKeys = new Set<string>()
    const filesToDownload: Array<{
      fileName: string
      subfolder: 'document' | 'images'
      downloadUrl?: string
    }> = []

    for (const attachment of deviceFormAttachmentList) {
      if (attachment.documentFileName) {
        const key = `document:${attachment.documentFileName}`
        if (!downloadedKeys.has(key)) {
          downloadedKeys.add(key)
          filesToDownload.push({
            fileName: attachment.documentFileName,
            subfolder: 'document',
            downloadUrl: (attachment as any).documentDownloadUrl,
          })
        }
      }

      if (attachment.documentFileIconURL) {
        const key = `images:${attachment.documentFileIconURL}`
        if (!downloadedKeys.has(key)) {
          downloadedKeys.add(key)
          filesToDownload.push({
            fileName: attachment.documentFileIconURL,
            subfolder: 'images',
          })
        }
      }
    }

    if (filesToDownload.length === 0) {
      return
    }

    console.log(
      `📥 [DOWNLOAD] Downloading ${filesToDownload.length} form cover attachment file(s)`
    )

    for (const attachmentFile of filesToDownload) {
      try {
        let downloadUrl = attachmentFile.downloadUrl
        if (!downloadUrl) {
          downloadUrl = await apiService
            .getDocumentDirectoryFilePath(attachmentFile.fileName, '')
            .toPromise()
        }

        if (!downloadUrl) {
          console.warn(
            `⚠️ [DOWNLOAD] No download URL for form cover attachment: ${attachmentFile.fileName}`
          )
          continue
        }

        await this.downloadDocumentFile(
          downloadUrl,
          attachmentFile.fileName,
          false,
          attachmentFile.subfolder
        )
      } catch (error) {
        console.error(
          `⚠️ [DOWNLOAD] Failed to download form cover attachment ${attachmentFile.fileName}:`,
          error
        )
      }
    }
  }

  appendEntityCondition = (entity: DeviceEntityDetail) => {
    if (entity?.projectID) {
      return 'projectID = ' + entity?.projectID
    } else if (entity?.locationID) {
      return 'locationID = ' + entity?.locationID
    } else if (entity?.inventoryItemID) {
      return 'inventoryItemID = ' + entity?.inventoryItemID
    }
  }

  convertToArray = (rows) => {
    let arr = []
    if (rows) {
      for (let index = 0; index < rows.length; index++) {
        let item = this.convertToObject(rows, index)
        arr.push(item)
      }
    }

    return arr
  }

  convertToObject = (rows, index = 0) => {
    let item = null
    if (rows?.item) {
      item = rows.item(index)
    } else {
      item = rows[index]
    }

    Object.keys(item).map((itemKey) => {
      try {
        item[itemKey] = JSON.parse(unescape(item[itemKey]))
      } catch (e) {}
    })
    return item
  }
  /****Get data from db*****/

  getAssignedEnitities() {
    return new Promise((resolve, reject) => {
      const query = 'SELECT * FROM DeviceEntities'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceDetail() {
    return new Promise((resolve, reject) => {
      const query = 'SELECT * FROM DeviceDetails'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getAvailableDocuments(folderId, entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)
      
      // Build condition based on folderId and entity
      if (folderId) {
        // If folderId exists, show documents in that folder
        if (condition) {
          // Entity condition exists: show documents matching entity OR documents with no entity association
          condition =
            '(' +
            condition +
            ' OR ' +
            this.emptyCond(['projectID', 'locationID', 'inventoryItemID']) +
            ') ' +
            ' AND  parentFolderID = ' +
            folderId
        } else {
          // No entity condition: show all documents in folder (with or without entity association)
          condition = 'parentFolderID = ' + folderId
        }
      } else {
        // No folderId: show root level documents
        if (condition) {
          // Entity condition exists: show documents matching entity AND no parentFolderID
          condition = condition + ' AND ' + this.emptyCond('parentFolderID')
        } else {
          // No entity condition: show all root level documents (no parentFolderID)
          condition = this.emptyCond('parentFolderID')
        }
      }

      const query =
        'SELECT * FROM DeviceAvailableDocuments' +
        (condition ? ' WHERE ' + condition : '')
      
      console.log('🔍 [OFFLINE] getAvailableDocuments query:', query);
      console.log('🔍 [OFFLINE] getAvailableDocuments entity:', entity);
      
      // Debug: Check what documents exist for this location
      if (entity?.locationID) {
        const debugQuery = `SELECT documentID, documentVersionID, documentVersionNo, parentFolderID, folderID, locationID, projectID, inventoryItemID, documentTitle FROM DeviceAvailableDocuments WHERE locationID = ${entity.locationID}`;
        this.dbQuery(debugQuery, []).then((debugRes: any) => {
          if (debugRes.rows?.length > 0) {
            const docsArray = this.convertToArray(debugRes.rows);
            const docsList = docsArray.map((d: any) => ({
              documentID: d.documentID,
              documentVersionID: d.documentVersionID,
              documentVersionNo: d.documentVersionNo,
              parentFolderID: d.parentFolderID,
              folderID: d.folderID,
              locationID: d.locationID,
              projectID: d.projectID,
              inventoryItemID: d.inventoryItemID,
              documentTitle: d.documentTitle
            }));
            console.log('🔍 [OFFLINE] Debug - All documents with locationID ' + entity.locationID + ':', {
              count: docsArray.length,
              documents: docsList
            });
            // Also log each document individually for easier debugging
            docsList.forEach((doc, idx) => {
              console.log(`🔍 [OFFLINE] Document ${idx + 1}/${docsList.length}:`, doc);
            });
            
            // Also check root level documents specifically
            const rootLevelQuery = `SELECT documentID, documentVersionID, documentTitle, parentFolderID, folderID, locationID FROM DeviceAvailableDocuments WHERE locationID = ${entity.locationID} AND (parentFolderID is NULL OR parentFolderID = 0 OR parentFolderID = '')`;
            this.dbQuery(rootLevelQuery, []).then((rootRes: any) => {
              if (rootRes.rows?.length > 0) {
                const rootDocs = this.convertToArray(rootRes.rows);
                console.log('🔍 [OFFLINE] Debug - Root level documents (parentFolderID is NULL/0):', {
                  count: rootDocs.length,
                  documents: rootDocs.map((d: any) => ({
                    documentID: d.documentID,
                    documentVersionID: d.documentVersionID,
                    documentTitle: d.documentTitle,
                    parentFolderID: d.parentFolderID,
                    folderID: d.folderID,
                    locationID: d.locationID
                  }))
                });
              } else {
                console.log('🔍 [OFFLINE] Debug - No root level documents found');
              }
            }).catch((rootError) => {
              console.error('🔍 [OFFLINE] Root level debug query error:', rootError);
            });
          } else {
            console.log('🔍 [OFFLINE] Debug - No documents found with locationID ' + entity.locationID);
          }
        }).catch((debugError) => {
          console.error('🔍 [OFFLINE] Debug query error:', debugError);
        });
      }
      
      this.dbQuery(query, [])
        .then((res: any) => {
          console.log('🔍 [OFFLINE] getAvailableDocuments result count:', res.rows?.length || 0);
          if (res.rows?.length > 0) {
            const list = this.convertToArray(res.rows)
            
            // Log all documents found by the query
            console.log('🔍 [OFFLINE] getAvailableDocuments - All documents from query:', list.map((d: any) => ({
              documentID: d.documentID,
              documentVersionID: d.documentVersionID,
              documentTitle: d.documentTitle,
              parentFolderID: d.parentFolderID,
              locationID: d.locationID,
              projectID: d.projectID,
              inventoryItemID: d.inventoryItemID,
              expirationDate: d.expirationDate
            })));

            const filtered = list.filter((item) => {
              if (
                item.expirationDate &&
                item.expirationDate !== StaticDataService.userDefaultDate &&
                item.expirationDate.indexOf(
                  StaticDataService.userUnsetDate,
                ) === -1
              ) {
                const isExpired = UtilService.isExpired(
                  item.expirationDate,
                  this.offlineDeviceDetailData.timeDifference,
                );
                if (isExpired) {
                  console.log(`🔍 [OFFLINE] getAvailableDocuments - Filtered out expired document:`, {
                    documentID: item.documentID,
                    documentVersionID: item.documentVersionID,
                    documentTitle: item.documentTitle,
                    expirationDate: item.expirationDate
                  });
                }
                return !isExpired;
              }
              return true
            });
            
            console.log('🔍 [OFFLINE] getAvailableDocuments - After expiration filter, count:', filtered.length);
            resolve(filtered);
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          console.error('🔍 [OFFLINE] getAvailableDocuments error:', error);
          reject(error)
        })
    })
  }

  getArchivedDocuments(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      // When offline, only show archives that have pending signoffs
      // Join with SignOffDetails to filter only pending signoffs
      let query = '';
      try {
        // Lazily inject SharedDataService to avoid circular dependency
        const sharedDataService = this.injector.get(SharedDataService, null);
        // Safely check if offline mode - if service not available, default to online behavior
        const isOffline = sharedDataService && 
                         typeof sharedDataService.offlineMode !== 'undefined' && 
                         sharedDataService.offlineMode === true;
        
        if (isOffline) {
          // Offline mode: only show archives with pending signoffs
          // Match by documentID and entity fields
          // Use COALESCE to handle NULL values (treat NULL as 0 for comparison)
          // Prefix condition with table alias to avoid ambiguous column name error
          const baseCondition = condition ? ' AND ad.' + condition : '';
          query = `
            SELECT DISTINCT ad.* 
            FROM DeviceArchivedDocuments ad
            WHERE (
              EXISTS (
                SELECT 1 
                FROM SignOffDetails sod
                WHERE sod.signOffDetailId = ad.signOffDetailId
                  AND sod.documentID > 0
                  AND (sod.formVersionID = 0 OR sod.formVersionID IS NULL)
              )
              OR (
                ad.signOffDetailId = 0
                AND (
                  ad.documentTitle LIKE 'Induction Sign-Off at%'
                  OR ad.documentTitle LIKE 'Visitor Agreement Sign-Off at%'
                )
              )
            )
            ${baseCondition}
            ORDER BY ad.createdDate DESC
          `;
          
          console.log('🔍 [ARCHIVE] getArchivedDocuments offline query:', query);
          
          // Debug: Check what archives and signoffs exist
          const debugArchiveQuery = `SELECT documentID, locationID, projectID, inventoryItemID, documentTitle FROM DeviceArchivedDocuments ${condition ? ' WHERE ' + condition : ''}`;
          const debugSignoffQuery = `SELECT documentID, locationID, projectID, inventoryItemID FROM SignOffDetails WHERE documentID > 0 AND (formVersionID = 0 OR formVersionID IS NULL)`;
          this.dbQuery(debugArchiveQuery, []).then((archiveRes: any) => {
            if (archiveRes?.rows?.length > 0) {
              const archives = this.convertToArray(archiveRes.rows);
              console.log('🔍 [ARCHIVE] Found document archives:', archives);
            } else {
              console.log('🔍 [ARCHIVE] No document archives found');
            }
          }).catch(() => {});
          this.dbQuery(debugSignoffQuery, []).then((signoffRes: any) => {
            if (signoffRes?.rows?.length > 0) {
              const signoffs = this.convertToArray(signoffRes.rows);
              console.log('🔍 [ARCHIVE] Found document signoffs:', signoffs);
            } else {
              console.log('🔍 [ARCHIVE] No document signoffs found');
            }
          }).catch(() => {});
        } else {
          // Online mode: show all archives
          query =
            'SELECT * FROM DeviceArchivedDocuments' +
            (condition ? ' WHERE ' + condition : '') +
            ' ORDER BY createdDate DESC';
        }
      } catch (error) {
        // If there's any error checking offline mode, default to online behavior
        console.warn('⚠️ [OFFLINE MANAGER] Error checking offline mode, defaulting to online behavior:', error);
        query =
          'SELECT * FROM DeviceArchivedDocuments' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY createdDate DESC';
      }

      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            const list = this.convertToArray(res.rows)
            list.map((item: any) => {
              let createdDate = moment(
                UtilService.fixTimeString(item.createdDate),
                StaticDataService.dateTimeFormat,
              )
              let currentDate = UtilService.todayCompanyDate(
                this.offlineDeviceDetailData.timeDifference,
                false,
              )
              let formattedCreatedDate =
                UtilService.durationNow(createdDate, currentDate) +
                ' (' +
                createdDate.format('DD MMM YYYY HH:mm') +
                ')'

              item.formattedCreatedDate = formattedCreatedDate
              item.todayDate = currentDate.format('YYYY-MM-DDTHH:mm:00.000')
            })

            resolve(list)
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getAvailableForms(folderId, entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)
      
      // Build condition based on folderId and entity
      if (folderId) {
        // If folderId exists, show forms in that folder
        if (condition) {
          // Entity condition exists: show forms matching entity OR forms with no entity association
          condition =
            '(' +
            condition +
            ' OR ' +
            this.emptyCond(['projectID', 'locationID', 'inventoryItemID']) +
            ') ' +
            ' AND  parentFormFolderID = ' +
            folderId
        } else {
          // No entity condition: show all forms in folder (with or without entity association)
          condition = 'parentFormFolderID = ' + folderId
        }
      } else {
        // No folderId: show root level forms
        if (condition) {
          // Entity condition exists: show forms matching entity AND no parentFormFolderID
          condition = condition + ' AND  ' + this.emptyCond('parentFormFolderID')
        } else {
          // No entity condition: show all root level forms (no parentFormFolderID)
          condition = this.emptyCond('parentFormFolderID')
        }
      }

      const query =
        'SELECT * FROM DeviceAvailableForms' +
        (condition ? ' WHERE ' + condition : '')
      
      console.log('🔍 [OFFLINE] getAvailableForms query:', query);
      console.log('🔍 [OFFLINE] getAvailableForms entity:', entity);
      
      this.dbQuery(query, [])
        .then((res: any) => {
          console.log('🔍 [OFFLINE] getAvailableForms result count:', res.rows?.length || 0);
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          console.error('🔍 [OFFLINE] getAvailableForms error:', error);
          reject(error)
        })
    })
  }

  getArchivedForms(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      // When offline, only show archives that have pending signoffs
      // Join with SignOffDetails to filter only pending signoffs
      let query = '';
      try {
        // Lazily inject SharedDataService to avoid circular dependency
        const sharedDataService = this.injector.get(SharedDataService, null);
        // Safely check if offline mode - if service not available, default to online behavior
        const isOffline = sharedDataService && 
                         typeof sharedDataService.offlineMode !== 'undefined' && 
                         sharedDataService.offlineMode === true;
        
        if (isOffline) {
          // Offline mode: only show archives that have pending signoffs
          // Match by formID (documentID in archive) - check if there's a signoff with matching formVersionID
          // We need to find the formVersionID from DeviceAvailableForms, then match with SignOffDetails
          // Use COALESCE to handle NULL values (treat NULL as 0 for comparison)
          // Prefix condition with table alias to avoid ambiguous column name error
          const baseCondition = condition ? ' AND af.' + condition : '';
          query = `
            SELECT DISTINCT af.* 
            FROM DeviceArchivedForms af
            WHERE (
              EXISTS (
                SELECT 1 
                FROM SignOffDetails sod
                WHERE (
                  (af.signOffDetailId > 0 AND sod.signOffDetailId = af.signOffDetailId)
                  OR (af.formSubmitDataId > 0 AND sod.formSubmitDataId = af.formSubmitDataId)
                )
                  AND sod.formVersionID > 0
              )
              OR (
                af.formSubmitDataId > 0
                AND af.documentTitle LIKE 'Induction Sign-Off at%'
              )
            )
            ${baseCondition}
            ORDER BY af.createdDate DESC
          `;
          
          console.log('🔍 [ARCHIVE] getArchivedForms offline query:', query);
          
          // Debug: Check what archives and signoffs exist
          const debugArchiveQuery = `SELECT documentID, formSubmitDataId, signOffDetailId, locationID, projectID, inventoryItemID, documentTitle FROM DeviceArchivedForms ${condition ? ' WHERE ' + condition : ''}`;
          const debugSignoffQuery = `SELECT signOffDetailId, formVersionID, formSubmitDataId, locationID, projectID, inventoryItemID FROM SignOffDetails WHERE formVersionID > 0`;
          const debugFormQuery = `SELECT formID, formVersionID, locationID, projectID, inventoryItemID FROM DeviceAvailableForms`;
          this.dbQuery(debugArchiveQuery, []).then((archiveRes: any) => {
            if (archiveRes?.rows?.length > 0) {
              const archives = this.convertToArray(archiveRes.rows);
              console.log('🔍 [ARCHIVE] Found archives:', archives);
            } else {
              console.log('🔍 [ARCHIVE] No archives found');
            }
          }).catch(() => {});
          this.dbQuery(debugSignoffQuery, []).then((signoffRes: any) => {
            if (signoffRes?.rows?.length > 0) {
              const signoffs = this.convertToArray(signoffRes.rows);
              console.log('🔍 [ARCHIVE] Found signoffs:', signoffs);
            } else {
              console.log('🔍 [ARCHIVE] No signoffs found');
            }
          }).catch(() => {});
          this.dbQuery(debugFormQuery, []).then((formRes: any) => {
            if (formRes?.rows?.length > 0) {
              const forms = this.convertToArray(formRes.rows);
              console.log('🔍 [ARCHIVE] Found forms in DeviceAvailableForms:', forms.map((f: any) => ({
                formID: f.formID,
                formVersionID: f.formVersionID,
                locationID: f.locationID
              })));
            } else {
              console.log('🔍 [ARCHIVE] No forms found in DeviceAvailableForms');
            }
          }).catch(() => {});
        } else {
          // Online mode: show all archives
          query =
            'SELECT * FROM DeviceArchivedForms' +
            (condition ? ' WHERE ' + condition : '') +
            ' ORDER BY createdDate DESC';
        }
      } catch (error) {
        // If there's any error checking offline mode, default to online behavior
        console.warn('⚠️ [OFFLINE MANAGER] Error checking offline mode, defaulting to online behavior:', error);
        query =
          'SELECT * FROM DeviceArchivedForms' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY createdDate DESC';
      }

      this.dbQuery(query, [])
        .then((res: any) => {
          const resultCount = res.rows?.length || 0;
          console.log('[SIGN-OFF ARCHIVE DEBUG] getArchivedForms result count:', resultCount);
          if (resultCount > 0) {
            const list = this.convertToArray(res.rows)
            console.log('[SIGN-OFF ARCHIVE DEBUG] getArchivedForms matched rows:', list.map((item: any) => ({
              documentID: item.documentID,
              documentTitle: item.documentTitle,
              formSubmitDataId: item.formSubmitDataId,
              signOffDetailId: item.signOffDetailId,
              locationID: item.locationID,
            })));
            list.map((item: any) => {
              let createdDate = moment(
                UtilService.fixTimeString(item.createdDate),
                StaticDataService.dateTimeFormat,
              )

              const currentDate = UtilService.todayCompanyDate(
                this.offlineDeviceDetailData.timeDifference,
                false,
              )

              const formattedCreatedDate =
                UtilService.durationNow(createdDate, currentDate) +
                ' (' +
                createdDate.format('DD MMM YYYY HH:mm') +
                ')'

              item.formattedCreatedDate = formattedCreatedDate
              item.todayDate = currentDate.format(
                StaticDataService.dateTimeFormatForDb,
              )
            })

            resolve(list)
          } else {
            console.log('[SIGN-OFF ARCHIVE DEBUG] getArchivedForms returned no rows — check formSubmitDataId/signOffDetailId link between DeviceArchivedForms and SignOffDetails');
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceLiveWorkPermits(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)
      const query =
        'SELECT * FROM DeviceLiveWorkPermits' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            const list = this.convertToArray(res.rows)
            let filteredList = []

            list.map((item: any) => {
              let isAvailable = false

              if (
                item.expiryDate &&
                item.expiryDate !== StaticDataService.userDefaultDate &&
                item.expiryDate.indexOf(StaticDataService.userUnsetDate) === -1
              ) {
                isAvailable = !UtilService.isExpired(
                  item.expiryDate,
                  this.offlineDeviceDetailData.timeDifference,
                  true,
                )
              } else {
                isAvailable = true
              }

              if (isAvailable) {
                const currentDateTime = UtilService.todayCompanyDate(
                  this.offlineDeviceDetailData.timeDifference,
                  false,
                )

                const issuedDateObj = moment(
                  UtilService.fixTimeString(item.issuedDate),
                  StaticDataService.dateTimeFormat,
                )
                const expiryDateObj = moment(
                  UtilService.fixTimeString(item.expiryDate),
                  StaticDataService.dateTimeFormat,
                )

                const formattedIssuedDate = UtilService.durationNow(
                  issuedDateObj,
                  currentDateTime,
                )
                const formattedExpiryDate =
                  UtilService.durationNow(
                    currentDateTime,
                    expiryDateObj,
                    false,
                  ) +
                  ' (' +
                  expiryDateObj.format('DD MMM YYYY HH:mm') +
                  ')'

                item.formattedIssuedDate = formattedIssuedDate
                item.formattedExpiryDate = formattedExpiryDate
                item.todayDate = currentDateTime.format(
                  'YYYY-MM-DDTHH:mm:00.000',
                )

                filteredList.push(item)
              }
            })

            resolve(filteredList)
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceArchivedWorkPermits(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      const addFormattedExpiryDate = (list) => {
        const currentDateTime = UtilService.todayCompanyDate(
          this.offlineDeviceDetailData.timeDifference,
          false,
        )

        list.forEach((item: any) => {
          const issuedDateObj = moment(
            UtilService.fixTimeString(item.issuedDate),
            StaticDataService.dateTimeFormat,
          )
          const expiryDateObj = moment(
            UtilService.fixTimeString(item.expiryDate),
            StaticDataService.dateTimeFormat,
          )

          const formattedIssuedDate = UtilService.durationNow(
            issuedDateObj,
            currentDateTime,
          )

          const formattedExpiryDate =
            UtilService.durationNow(expiryDateObj, currentDateTime) +
            ' (' +
            expiryDateObj.format('DD MMM YYYY HH:mm') +
            ')'

          item.formattedIssuedDate = formattedIssuedDate
          item.formattedExpiryDate = formattedExpiryDate
          item.todayDate = currentDateTime.format(
            StaticDataService.dateTimeFormat,
          )
        })

        resolve(list)
      }

      const getExpiredPermits = (archivedPermitList) => {
        let expiredCondition = this.appendEntityCondition(entity)
        const qxpiredQuery =
          'SELECT * FROM DeviceLiveWorkPermits' +
          (expiredCondition ? ' WHERE ' + expiredCondition : '')

        this.dbQuery(qxpiredQuery, [])
          .then((res: any) => {
            if (res.rows?.length > 0) {
              const list = this.convertToArray(res.rows)

              const filteredList = list.filter((item: any) => {
                if (
                  item.expiryDate &&
                  item.expiryDate !== StaticDataService.userDefaultDate &&
                  item.expiryDate.indexOf(StaticDataService.userUnsetDate) ===
                    -1
                ) {
                  return UtilService.isExpired(
                    item.expiryDate,
                    this.offlineDeviceDetailData.timeDifference,
                    true,
                  )
                }
                return false
              })

              const finalList = filteredList.concat(archivedPermitList)

              addFormattedExpiryDate(finalList)
            } else {
              addFormattedExpiryDate(archivedPermitList)
            }
          })
          .catch((error) => {
            addFormattedExpiryDate(archivedPermitList)
          })
      }

      const query =
        'SELECT * FROM DeviceArchivedWorkPermits' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            getExpiredPermits(this.convertToArray(res.rows))
          } else {
            getExpiredPermits([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceAvailableWorkPermits(entity: DeviceEntityDetail, folderId = 0) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)
      if (folderId) {
        condition =
          '(' +
          condition +
          ' OR ' +
          this.emptyCond(['projectID', 'locationID', 'inventoryItemID']) +
          ') ' +
          ' AND  parentFormFolderID = ' +
          folderId
      } else {
        condition = condition + ' AND  ' + this.emptyCond('parentFormFolderID')
      }

      const query =
        'SELECT * FROM DeviceAvailableWorkPermits' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceEvacuations(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      const query =
        'SELECT DeviceEvacuations.*, ImageVideoFiles.fileName as offlineUserPhoto  FROM DeviceEvacuations LEFT JOIN ImageVideoFiles ON DeviceEvacuations.userPhotoImageVideoFileId=ImageVideoFiles.imageVideoFileId' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY firstAndLastName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          const rows = res.rows?.length > 0 ? this.convertToArray(res.rows) : []
          console.log('[EVAC] list:offline | count:', rows.length, '| names:', rows.map((r: any) => r.firstAndLastName))
          if (rows.length > 0) {
            resolve(rows)
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceCompanyUsers(name = '') {
    return new Promise((resolve, reject) => {
      let condition = ''
      if (name) {
        condition =
          condition + "LOWER(firstAndLastName) LIKE LOWER('%" + name + "%')"
      }

      const query =
        'SELECT * FROM DeviceCompanyUsers' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY firstAndLastName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceCompanyUserGroups() {
    return new Promise((resolve, reject) => {
      const query =
        'SELECT * FROM DeviceCompanyUserGroups ORDER BY groupName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceUsers(name) {
    return new Promise((resolve, reject) => {
      let condition = ''

      if (name) {
        condition =
          condition +
          "LOWER(firstAndLastName) LIKE LOWER('%" +
          name +
          "%') OR LOWER(fullName) LIKE LOWER('%" +
          name +
          "%')"
      }

      const query =
        'SELECT *, firstName || " " || lastName as firstAndLastName, firstName || " " || middleName || " " || lastName as fullName FROM DeviceUsers' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY firstAndLastName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceHazardItems(companyId, companyRiskItemID) {
    return new Promise((resolve, reject) => {
      let conitionObj = {
        companyID: companyId,
        companyRiskItemID: companyRiskItemID,
      }
      let condition = this.convertObjectToConditionString(conitionObj)

      const query =
        'SELECT * FROM DeviceHazardItems' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceRiskAssessmentSeverityOptions() {
    return new Promise((resolve, reject) => {
      const query = 'SELECT * FROM DeviceRiskAssessmentSeverityOptions'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceRiskAssessmentProbabilityOptions() {
    return new Promise((resolve, reject) => {
      const query = 'SELECT * FROM DeviceRiskAssessmentProbabilityOptions'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceRiskItems() {
    return new Promise((resolve, reject) => {
      const query = 'SELECT * FROM DeviceRiskItems'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceIOSHItems(companyId) {
    return new Promise((resolve, reject) => {
      const harmTypesPromise = this.dbQuery(
        'SELECT * FROM DeviceIOSHHarmTypes WHERE companyID = ?',
        [companyId]
      );
      
      const hazardCategoriesPromise = this.dbQuery(
        'SELECT * FROM DeviceIOSHHazardCategories WHERE companyID = ?',
        [companyId]
      );
      
      const hazardControlsPromise = this.dbQuery(
        'SELECT * FROM DeviceIOSHHazardControls WHERE companyID = ?',
        [companyId]
      );
  
      Promise.all([harmTypesPromise, hazardCategoriesPromise, hazardControlsPromise])
        .then(([harmTypesRes, hazardCategoriesRes, hazardControlsRes]: any[]) => {
          // Map database fields to UI-expected format
          const harmTypes = harmTypesRes.rows?.length > 0 
            ? this.convertToArray(harmTypesRes.rows).map(item => ({
                companyIosHarmTypeID: item.companyIosHarmTypeID,
                companyIOSHHarmTypeID: item.companyIosHarmTypeID, // Add uppercase version for compatibility
                ioshHarmName: item.ioshHarmName,
                companyID: item.companyID
              }))
            : [];
          
          const hazardCategories = hazardCategoriesRes.rows?.length > 0 
            ? this.convertToArray(hazardCategoriesRes.rows).map(item => ({
                companyIoshHazardCategoryID: item.companyIoshHazardCategoryID,
                companyIOSHHazardCategoryID: item.companyIoshHazardCategoryID, // Add uppercase version for compatibility
                ioshHazardName: item.ioshHazardName,
                companyID: item.companyID
              }))
            : [];
          
          const hazardControls = hazardControlsRes.rows?.length > 0 
            ? this.convertToArray(hazardControlsRes.rows).map(item => ({
                companyIoshHazardControlID: item.companyIoshHazardControlID,
                companyIOSHHazardControlID: item.companyIoshHazardControlID, // Add uppercase version for compatibility
                ioshHazardControlName: item.ioshHazardControlName,
                companyIoshHazardCategoryID: item.companyIoshHazardCategoryID,
                companyIOSHHazardCategoryID: item.companyIoshHazardCategoryID, // Add uppercase version for compatibility
                companyID: item.companyID
              }))
            : [];
          
          resolve({
            companyIOSHHarmTypes: harmTypes,
            companyIOSHHazardCategories: hazardCategories,
            companyIOSHHazardControls: hazardControls
          });
        })
        .catch((error) => {
          console.error('Error fetching IOSH items:', error);
          resolve({
            companyIOSHHarmTypes: [],
            companyIOSHHazardCategories: [],
            companyIOSHHazardControls: []
          });
        });
    });
  }

  saveDeviceIOSHItems(companyId, ioshItems) {
    return new Promise(async (resolve, reject) => {
      try {
        // Clear existing IOSH items for this company
        await this.emptyTable('DeviceIOSHHarmTypes', `companyID = ${companyId}`);
        await this.emptyTable('DeviceIOSHHazardCategories', `companyID = ${companyId}`);
        await this.emptyTable('DeviceIOSHHazardControls', `companyID = ${companyId}`);

        // Insert Harm Types
        if (ioshItems?.companyIOSHHarmTypes && Array.isArray(ioshItems.companyIOSHHarmTypes)) {
          for (const harmType of ioshItems.companyIOSHHarmTypes) {
            const data = {
              companyIosHarmTypeID: harmType.companyIosHarmTypeID || harmType.companyIOSHHarmTypeID || 0,
              ioshHarmName: harmType.ioshHarmName || '',
              companyID: companyId
            };
            await this.insertData('DeviceIOSHHarmTypes', data, {});
          }
        }

        // Insert Hazard Categories
        if (ioshItems?.companyIOSHHazardCategories && Array.isArray(ioshItems.companyIOSHHazardCategories)) {
          for (const hazardCategory of ioshItems.companyIOSHHazardCategories) {
            const data = {
              companyIoshHazardCategoryID: hazardCategory.companyIoshHazardCategoryID || hazardCategory.companyIOSHHazardCategoryID || 0,
              ioshHazardName: hazardCategory.ioshHazardName || '',
              companyID: companyId
            };
            await this.insertData('DeviceIOSHHazardCategories', data, {});
          }
        }

        // Insert Hazard Controls
        if (ioshItems?.companyIOSHHazardControls && Array.isArray(ioshItems.companyIOSHHazardControls)) {
          for (const hazardControl of ioshItems.companyIOSHHazardControls) {
            const data = {
              companyIoshHazardControlID: hazardControl.companyIoshHazardControlID || hazardControl.companyIOSHHazardControlID || 0,
              ioshHazardControlName: hazardControl.ioshHazardControlName || '',
              companyIoshHazardCategoryID: hazardControl.companyIoshHazardCategoryID || hazardControl.companyIOSHHazardCategoryID || 0,
              companyID: companyId
            };
            await this.insertData('DeviceIOSHHazardControls', data, {});
          }
        }

        resolve(true);
      } catch (error) {
        console.error('Error saving IOSH items:', error);
        reject(error);
      }
    });
  }

  getGuestUserDetailByPhone(phone) {
    return new Promise((resolve, reject) => {
      let condition = ''
      if (phone) {
        condition =
          condition + "CAST(guestPhone AS TEXT) = CAST('" + phone + "' AS TEXT)"
      }

      const query =
        'SELECT * FROM DeviceGuestUsers' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY guestFirsName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          const matchedRows = res.rows?.length > 0 ? this.convertToArray(res.rows) : []
          console.log('[EVAC] phone-lookup | phone:', phone, '| found:', matchedRows.length > 0 ? (matchedRows[0].guestFirsName + ' ' + matchedRows[0].guestLastName) : 'no match')
          if (matchedRows.length > 0) {
            const picked = this.convertToObject(res.rows) // always index 0
            resolve(picked)
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getUserDetailByQRCode(qrcode) {
    return new Promise((resolve, reject) => {
      let condition = ''
      if (qrcode) {
        condition = condition + "qrCode = '" + qrcode + "'"
      }

      const query =
        'SELECT * FROM DeviceUsers' + (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceUserById(userId: string): Promise<DeviceUserDetail | null> {
    return new Promise((resolve, reject) => {
      const query = `SELECT * FROM DeviceUsers WHERE userId = "${userId}"`
      this.dbQuery(query, [])
        .then((res: any) => {
          resolve(res.rows?.length > 0 ? this.convertToObject(res.rows) : null)
        })
        .catch((error) => reject(error))
    })
  }

  getAnswerChoiceEntityByQRCode(qrCode) {
    return new Promise(async (resolve, reject) => {
      let condition = ''
      if (qrCode) {
        condition = condition + ' qrCode="' + qrCode + '"'
      }
      // Get DeviceInventoryItems
      let query =
        'SELECT * FROM DeviceAnswerChoiceQrCodeEntities' +
        (condition ? ' WHERE ' + condition : '')
      const inventryItemsRes: any = await this.dbQuery(query, [])
      if (inventryItemsRes && inventryItemsRes.rows?.length > 0) {
        const inventoryItem = this.convertToObject(inventryItemsRes.rows)
        resolve(inventoryItem)
      } else {
        resolve(null)
      }
    })
  }

  getDeviceUserLastCheckinDetail(
    entity: DeviceEntityDetail,
    userIdOrGuestPhone,
    isGuest = false,
  ) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)
      let query
      if (isGuest) {
        condition = condition + ' AND guestPhone = "' + userIdOrGuestPhone + '"'
        query =
          'SELECT * FROM DeviceGuestUserLastCheckinDetailList' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY checkInDate DESC'
      } else {
        condition = condition + ' AND userId = "' + userIdOrGuestPhone + '"'
        query =
          'SELECT * FROM DeviceUserLastCheckinDetailList' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY checkInDate DESC'
      }

      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(null)
        })
    })
  }

  /**
   * Evacuation row for company user at entity (online check-in updates evacuation only).
   */
  findEvacuationRowForCompanyUserAtEntity = (
    userId: string,
    entity: DeviceEntityDetail,
  ): Promise<any | null> => {
    return new Promise((resolve) => {
      const base = this.appendEntityCondition(entity)
      if (!base || !userId) {
        resolve(null)
        return
      }
      const q =
        'SELECT * FROM DeviceEvacuations WHERE ' +
        base +
        ' AND userId = "' +
        userId +
        '"'
      this.dbQuery(q, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows, 0))
          } else {
            resolve(null)
          }
        })
        .catch(() => resolve(null))
    })
  }

  /**
   * Evacuation row for guest at entity — looks up name from DeviceGuestUsers then matches by firstAndLastName.
   */
  findEvacuationRowForGuestAtEntity = async (
    guestPhone: string,
    entity: DeviceEntityDetail,
  ): Promise<{ evacRow: any; guestUser: any } | null> => {
    const base = this.appendEntityCondition(entity)
    if (!base || !guestPhone) {
      return null
    }
    const userRes: any = await this.dbQuery(
      'SELECT * FROM DeviceGuestUsers WHERE CAST(guestPhone AS TEXT) = CAST("' + guestPhone + '" AS TEXT) LIMIT 1',
      [],
    ).catch(() => null)
    if (!userRes || !(userRes.rows?.length > 0)) {
      return null
    }
    const guestUser = this.convertToObject(userRes.rows, 0)
    const firstAndLastName = (
      (guestUser.guestFirsName || '') +
      ' ' +
      (guestUser.guestMiddleName ? guestUser.guestMiddleName + ' ' : '') +
      (guestUser.guestLastName || '')
    ).trim()
    if (!firstAndLastName) {
      return null
    }
    const evacRes: any = await this.dbQuery(
      'SELECT * FROM DeviceEvacuations WHERE ' + base + ' AND firstAndLastName = "' + firstAndLastName + '"',
      [],
    ).catch(() => null)
    if (!evacRes || !(evacRes.rows?.length > 0)) {
      return null
    }
    return { evacRow: this.convertToObject(evacRes.rows, 0), guestUser }
  }

  /**
   * Minimal open check-in row so offline checkout has deviceUserCheckinDetailId (mirrors server-only check-in).
   */
  private async insertShadowOpenCheckinFromEvacuation(
    evacRow: any,
    entity: DeviceEntityDetail,
    userId: string,
  ): Promise<number | null> {
    try {
      let entityData: any = {}
      if (entity.locationID) {
        entityData = await this.getDeviceLocationDetail(entity.locationID)
      } else if (entity.projectID) {
        entityData = await this.getDeviceProjectDetail(entity.projectID)
      } else if (entity.inventoryItemID) {
        entityData = await this.getDeviceInventoryItemDetail(
          entity.inventoryItemID,
        )
      }
      const utcDateTime = moment()
        .utc()
        .format(StaticDataService.dateTimeFormat)
      const entityName =
        entityData?.locationName ||
        entityData?.projectName ||
        entityData?.itemName ||
        ''
      const data: any = {
        checkInDate: utcDateTime,
        companyID: entityData?.companyID || 0,
        currentUTCDate: utcDateTime,
        entityName: entityName || '',
        firstAndLastName: evacRow.firstAndLastName || '',
        firstName: evacRow.firstName || '',
        lastName: evacRow.lastName || '',
        isOfflineDone: true,
        isSimultaneousCheckIn: entityData?.isSimultaneousCheckIn || false,
        inventoryItemID: entity.inventoryItemID || 0,
        locationID: entity.locationID || 0,
        projectID: entity.projectID || 0,
        userDetailPhoto: evacRow.userDetailPhoto || '',
        userId,
        userPhoto: evacRow.userPhoto || '',
        userPhotoImageVideoFileId: evacRow.userPhotoImageVideoFileId || 0,
        locationAutoCheckOutHour: entityData?.autoCheckOutHour || '',
        locationAutoCheckOutTime: entityData?.autoCheckOutTime || '',
        userAutoCheckOutTime: '',
        userCheckInDetailID: 0,
        processInductionsteps: false,
      }
      const {
        dataCols,
        dataVals,
        dataValPlaceHolders,
      } = this.convertObjectToColValPlaceholders(
        data,
        'DeviceUserCheckinDetails',
      )
      if (dataCols.length === 0) {
        return null
      }
      let query =
        'INSERT INTO DeviceUserCheckinDetails (' +
        dataCols.join(',') +
        ') select ' +
        dataValPlaceHolders.join(',') +
        ''
      await this.dbQuery(query, dataVals)
      const lidRes: any = await this.dbQuery(
        'SELECT last_insert_rowid() as lid',
        [],
      )
      let lid: number | null = null
      if (lidRes?.rows?.length > 0 && lidRes.rows.item) {
        lid = Number(lidRes.rows.item(0).lid)
      } else if (lidRes?.[0]?.lid != null) {
        lid = Number(lidRes[0].lid)
      }
      return lid != null && !Number.isNaN(lid) ? lid : null
    } catch (e) {
      console.warn('insertShadowOpenCheckinFromEvacuation failed', e)
      return null
    }
  }

  /**
   * Minimal open check-in row in DeviceGuestUserCheckinDetails so offline checkout can proceed (mirrors server-only guest check-in).
   */
  private async insertShadowOpenCheckinFromEvacuationForGuest(
    evacRow: any,
    entity: DeviceEntityDetail,
    guestPhone: string,
    guestUser: any,
  ): Promise<number | null> {
    try {
      let entityData: any = {}
      if (entity.locationID) {
        entityData = await this.getDeviceLocationDetail(entity.locationID)
      } else if (entity.projectID) {
        entityData = await this.getDeviceProjectDetail(entity.projectID)
      } else if (entity.inventoryItemID) {
        entityData = await this.getDeviceInventoryItemDetail(entity.inventoryItemID)
      }
      const utcDateTime = moment().utc().format(StaticDataService.dateTimeFormat)
      const entityName =
        entityData?.locationName ||
        entityData?.projectName ||
        entityData?.itemName ||
        ''
      const firstAndLastName = (
        (guestUser.guestFirsName || '') +
        ' ' +
        (guestUser.guestMiddleName ? guestUser.guestMiddleName + ' ' : '') +
        (guestUser.guestLastName || '')
      ).trim()
      const data: any = {
        guestPhone,
        guestFirsName: guestUser.guestFirsName || '',
        guestMiddleName: guestUser.guestMiddleName || '',
        guestLastName: guestUser.guestLastName || '',
        firstAndLastName,
        checkInDate: utcDateTime,
        checkOutDate: '',
        entityName: entityName || '',
        companyID: entityData?.companyID || 0,
        locationID: entity.locationID || 0,
        projectID: entity.projectID || 0,
        inventoryItemID: entity.inventoryItemID || 0,
        isSimultaneousCheckIn: entityData?.isSimultaneousCheckIn || false,
        isOfflineDone: true,
      }
      const { dataCols, dataVals, dataValPlaceHolders } = this.convertObjectToColValPlaceholders(data, 'DeviceGuestUserCheckinDetails')
      if (dataCols.length === 0) {
        return null
      }
      const query =
        'INSERT INTO DeviceGuestUserCheckinDetails (' +
        dataCols.join(',') +
        ') select ' +
        dataValPlaceHolders.join(',') +
        ''
      await this.dbQuery(query, dataVals)
      const lidRes: any = await this.dbQuery('SELECT last_insert_rowid() as lid', [])
      let lid: number | null = null
      if (lidRes?.rows?.length > 0 && lidRes.rows.item) {
        lid = Number(lidRes.rows.item(0).lid)
      } else if (lidRes?.[0]?.lid != null) {
        lid = Number(lidRes[0].lid)
      }
      return lid != null && !Number.isNaN(lid) ? lid : null
    } catch (e) {
      console.warn('insertShadowOpenCheckinFromEvacuationForGuest failed', e)
      return null
    }
  }

  getDeviceUserCheckinDetails(
    entity: DeviceEntityDetail,
    userIdOrGuestPhone,
    isGuest = false,
  ) {
    return new Promise((resolve, reject) => {
      let query
      const checkoutDateCondition =
        '(checkOutDate is NULL OR checkOutDate="" OR checkOutDate="' +
        StaticDataService.userDefaultDate +
        '")'
      if (isGuest) {
        const condition =
          ' guestPhone = "' +
          userIdOrGuestPhone +
          '" AND ' +
          checkoutDateCondition
        query =
          'SELECT * FROM DeviceGuestUserCheckinDetails' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY checkInDate DESC'
      } else {
        const condition =
          ' userId = "' + userIdOrGuestPhone + '" AND ' + checkoutDateCondition
        query =
          'SELECT * FROM DeviceUserCheckinDetails' +
          (condition ? ' WHERE ' + condition : '') +
          ' ORDER BY checkInDate DESC'
      }

      this.dbQuery(query, [])
        .then(async (res: any) => {
          const deviceUserCheckinDetails = this.convertToArray(res.rows)
          console.log('[GUEST-SCREEN] getDeviceUserCheckinDetails | isGuest:', isGuest, '| phone/userId:', userIdOrGuestPhone, '| rows in checkin table:', res.rows?.length ?? 0, '| rows:', deviceUserCheckinDetails?.map((r: any) => ({ locationID: r.locationID, checkOutDate: r.checkOutDate, isOfflineDone: r.isOfflineDone })));

          let isAlreadyCheckinToThisEntity = false
          let isSimultaneousCheckInAllowed = true
          let currentCheckinLocation

          // Get list of assgined enity to the device
          let deviceAssginedLocationIds = []
          let deviceAssginedProjectIds = []
          let deviceAssginedInventoryItemIds = []
          const deviceAssginedEntity = localStorage.getItem(
            EnumService.LocalStorageKeys.DEDICATED_MODE_ASSIGNED_ENTITIES,
          )
          if (deviceAssginedEntity) {
            try {
              const list = JSON.parse(deviceAssginedEntity)
              list.map((obj) => {
                if (obj.locationID) {
                  deviceAssginedLocationIds.push(obj.locationID)
                } else if (obj.projectID) {
                  deviceAssginedProjectIds.push(obj.projectID)
                } else if (obj.inventoryItemID) {
                  deviceAssginedInventoryItemIds.push(obj.inventoryItemID)
                }
              })
            } catch (error) {}
          }

          if (res.rows?.length > 0) {
            if (
              deviceUserCheckinDetails &&
              deviceUserCheckinDetails.length > 0
            ) {
              // Check if already checking to this entity
              deviceUserCheckinDetails.some((item) => {
                if (
                  (entity.locationID &&
                    entity.locationID === item.locationID) ||
                  (entity.projectID && entity.projectID === item.projectID) ||
                  (entity.inventoryItemID &&
                    entity.inventoryItemID === item.inventoryItemID)
                ) {
                  isAlreadyCheckinToThisEntity = true
                  currentCheckinLocation = item
                  return true
                }
              })

              // Check if SimultaneousCheckIn allowed or not
              deviceUserCheckinDetails.some((item) => {
                const locationIsAssigned =
                  (item.locationID &&
                    deviceAssginedLocationIds.indexOf(item.locationID) !==
                      -1) ||
                  (item.projectID &&
                    deviceAssginedProjectIds.indexOf(item.projectID) !== -1) ||
                  (item.inventoryItemID &&
                    deviceAssginedInventoryItemIds.indexOf(
                      item.inventoryItemID,
                    ) !== -1)
                if (locationIsAssigned && !item.isSimultaneousCheckIn) {
                  isSimultaneousCheckInAllowed = false
                  currentCheckinLocation = item
                  return true
                }
              })
            }

            console.log('[GUEST-SCREEN] isAlreadyCheckinToThisEntity:', isAlreadyCheckinToThisEntity, '| isSimultaneousCheckInAllowed:', isSimultaneousCheckInAllowed);
            if (isAlreadyCheckinToThisEntity || !isSimultaneousCheckInAllowed) {
              // let entityData: any;
              let Field = ''
              let Message = ''
              let entityId = isGuest
                ? currentCheckinLocation.deviceGuestUserCheckinDetailId
                : currentCheckinLocation.deviceUserCheckinDetailId
              let entityName = currentCheckinLocation.entityName

              if (isAlreadyCheckinToThisEntity) {
                Field = 'Location#' + entityId
                Message = "'" + entityName + "'"
              } else if (!isSimultaneousCheckInAllowed) {
                Field = 'SimultaneousCheckIn#' + entityId
                Message = "'" + entityName + "'"
              }

              const response = {
                error: {
                  Version: '1.0',
                  StatusCode: 402,
                  Message: '',
                  Result: null,
                  ResponseException: {
                    IsError: true,
                    ExceptionMessage: {},
                    Details: '',
                    ReferenceErrorCode: '',
                    ReferenceDocumentLink: '',
                    ValidationErrors: [
                      {
                        Field: Field,
                        Message: Message,
                      },
                    ],
                  },
                },
              }
              reject(response)
            } else {
              onSuccess(deviceUserCheckinDetails)
            }
          } else {
            // Checked in online only: evacuation was updated but no local open check-in row yet.
            console.log('[GUEST-SCREEN] no rows in checkin table | isGuest:', isGuest, '→ checking DeviceEvacuations fallback');
            const buildRejectResponse = (shadowId: number, entityName: string, fallbackName: string) => {
              return {
                error: {
                  Version: '1.0',
                  StatusCode: 402,
                  Message: '',
                  Result: null,
                  ResponseException: {
                    IsError: true,
                    ExceptionMessage: {},
                    Details: '',
                    ReferenceErrorCode: '',
                    ReferenceDocumentLink: '',
                    ValidationErrors: [
                      {
                        Field: 'Location#' + shadowId,
                        Message: "'" + (entityName || fallbackName) + "'",
                      },
                    ],
                  },
                },
              }
            }
            const resolveEntityName = async (): Promise<string> => {
              try {
                if (entity.locationID) {
                  const loc: any = await this.getDeviceLocationDetail(entity.locationID)
                  return loc?.locationName || ''
                } else if (entity.projectID) {
                  const p: any = await this.getDeviceProjectDetail(entity.projectID)
                  return p?.projectName || ''
                } else if (entity.inventoryItemID) {
                  const inv: any = await this.getDeviceInventoryItemDetail(entity.inventoryItemID)
                  return inv?.itemName || ''
                }
              } catch (e) {}
              return ''
            }
            if (isGuest) {
              const guestFallback = await this.findEvacuationRowForGuestAtEntity(userIdOrGuestPhone, entity)
              if (guestFallback) {
                const shadowId = await this.insertShadowOpenCheckinFromEvacuationForGuest(
                  guestFallback.evacRow,
                  entity,
                  userIdOrGuestPhone,
                  guestFallback.guestUser,
                )
                if (shadowId != null) {
                  const entityName = await resolveEntityName()
                  reject(buildRejectResponse(shadowId, entityName, guestFallback.evacRow.firstAndLastName || ''))
                  return
                }
              }
            } else {
              const evacRow = await this.findEvacuationRowForCompanyUserAtEntity(
                userIdOrGuestPhone,
                entity,
              )
              if (evacRow) {
                const shadowId = await this.insertShadowOpenCheckinFromEvacuation(
                  evacRow,
                  entity,
                  userIdOrGuestPhone,
                )
                if (shadowId != null) {
                  const entityName = await resolveEntityName()
                  reject(buildRejectResponse(shadowId, entityName, evacRow.firstAndLastName || ''))
                  return
                }
              }
            }
            onSuccess(null)
          }
        })
        .catch((error) => {
          reject(error)
        })

      const onSuccess = async (deviceUserCheckinDetails) => {
        let entityData: any
        if (entity.locationID) {
          entityData = await this.getDeviceLocationDetail(entity.locationID)
        } else if (entity.projectID) {
          entityData = await this.getDeviceProjectDetail(entity.projectID)
        } else if (entity.inventoryItemID) {
          entityData = await this.getDeviceInventoryItemDetail(
            entity.inventoryItemID,
          )
        }

        const checkInEntityDetail = {
          checkInGuestPhoto: entityData.checkInGuestPhoto,
          checkInPersonalPhoto: entityData.checkInPersonalPhoto,
          checkInPersonalQR: entityData.checkInPersonalQR,
          inventoryItemID: entity.inventoryItemID,
          locationID: entity.locationID,
          processInduction: false,
          projectID: entity.projectID,
        }
        const inductionDetail: any = isGuest
          ? await this.getDeviceCheckInGuestInductionDetail(entity)
          : await this.getDeviceCheckInInductionDetail(entity)
        let checkInInductionItems: any = []

        if (inductionDetail) {
          // Check induction process
          const lastCheckinForCurrentLocation: any = await this.getDeviceUserLastCheckinDetail(
            entity,
            userIdOrGuestPhone,
            isGuest,
          )
          if (lastCheckinForCurrentLocation) {
            if (lastCheckinForCurrentLocation.showInductionSteps) {
              checkInEntityDetail.processInduction = true
            } else {
              const renewEveryPeriodType = inductionDetail.renewEveryPeriodType
              const renewEveryPeriod = inductionDetail.renewEveryPeriod
              if (renewEveryPeriodType && renewEveryPeriod) {
                const lastCheckinDateObj = moment
                  .utc(
                    UtilService.fixTimeString(
                      lastCheckinForCurrentLocation.checkInDate,
                    ),
                    StaticDataService.dateTimeFormat,
                  )
                  .startOf('day')

                const currentDate = moment().utc().startOf('day')

                const diff = currentDate.diff(
                  lastCheckinDateObj,
                  renewEveryPeriodType.toLowerCase(),
                  true,
                )
                if (diff >= renewEveryPeriod) {
                  checkInEntityDetail.processInduction = true
                }
              }
            }
          } else {
            checkInEntityDetail.processInduction = true
          }

          checkInInductionItems = isGuest
            ? await this.getDeviceCheckInGuestInductionItems(
                inductionDetail.checkInInductionGuestID,
              )
            : await this.getDeviceCheckInInductionItems(
                inductionDetail.checkInInductionID,
              )
        }

        resolve({
          checkInEntityDetail: checkInEntityDetail,
          checkInInduction: inductionDetail,
          checkInInductionItems: checkInInductionItems,
        })
      }
    })
  }

  getDeviceCheckInInductionDetail(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      const query =
        'SELECT * FROM DeviceCheckInInductions' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceCheckInGuestInductionDetail(entity: DeviceEntityDetail) {
    return new Promise((resolve, reject) => {
      let condition = this.appendEntityCondition(entity)

      const query =
        'SELECT * FROM DeviceCheckInGuestInductions' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceCheckInInductionItems(checkInInductionID: string) {
    return new Promise((resolve, reject) => {
      let condition = 'checkInInductionID=' + checkInInductionID

      const query =
        'SELECT * FROM DeviceCheckInInductionItems' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceCheckInGuestInductionItems(checkInInductionGuestID: string) {
    return new Promise((resolve, reject) => {
      let condition = 'checkInInductionGuestID=' + checkInInductionGuestID

      const query =
        'SELECT * FROM DeviceCheckInGuestInductionItems' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceInventoryItemDetail(inventoryItemID: any) {
    return new Promise((resolve, reject) => {
      let condition = 'inventoryItemID=' + inventoryItemID

      const query =
        'SELECT * FROM DeviceInventoryItems' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceLocationDetail(locationID: any) {
    return new Promise((resolve, reject) => {
      let condition = 'locationID=' + locationID

      const query =
        'SELECT * FROM DeviceLocations' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceProjectDetail(projectID: any) {
    return new Promise((resolve, reject) => {
      let condition = 'projectID=' + projectID

      const query =
        'SELECT * FROM DeviceProjects' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getManufacturerList(companyId) {
    return new Promise((resolve, reject) => {
      const condition = 'companyID=' + companyId

      const query =
        'SELECT * FROM DeviceHAVManufacturers' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY havManufacturerName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getTypeList(companyId, manufacturerId) {
    return new Promise((resolve, reject) => {
      const condition =
        'companyID=' + companyId + ' AND havManufacturerID=' + manufacturerId

      const query =
        'SELECT * FROM DeviceHAVTypes' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY havTypeName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getModelList(companyId, typeId) {
    return new Promise((resolve, reject) => {
      const condition = 'companyID=' + companyId + ' AND havTypeID=' + typeId

      const query =
        'SELECT * FROM DeviceHAVModels' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY model ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getDeviceAccidentTypeList() {
    return new Promise((resolve, reject) => {
      const query =
        'SELECT * FROM DeviceAccidentTypes ORDER BY accidentTypeTitle ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getDeviceAccidentClassificationList() {
    return new Promise((resolve, reject) => {
      const query =
        'SELECT * FROM DeviceAccidentClassifications ORDER BY accidentClassificationTitle ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getDeviceLocationItemList() {
    return new Promise((resolve, reject) => {
      const query =
        'SELECT * FROM DeviceLocationItems ORDER BY locationName ASC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getDeviceUserCheckInQualifications(entity) {
    return new Promise((resolve) => {
      let condition = this.appendEntityCondition(entity)
      const query =
        'SELECT * FROM DeviceUserCheckInQualifications' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getDeviceUserQualifications(userId) {
    return new Promise((resolve) => {
      let condition = 'userId = "' + userId + '"'
      const query =
        'SELECT * FROM DeviceUserQualifications' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getFormDetail(formId, formVersionId, formVersionNo, folderId = null) {
    return new Promise((resolve, reject) => {
      console.log('🔍 [GET FORM DETAIL] Called with:', {
        formId,
        formVersionId,
        formVersionNo,
        folderId
      });

      // Use correct column names: formID, formVersionID (PascalCase) to match database schema
      let condition =
        'formID = ' +
        formId +
        ' AND formVersionID = ' +
        formVersionId +
        ' AND formVersionNo = ' +
        formVersionNo
      if (folderId) {
        condition = condition + ' AND  parentFormFolderID = ' + folderId
      } else {
        condition = condition + ' AND  ' + this.emptyCond('parentFormFolderID')
      }
      const query = 'SELECT * FROM DeviceFormDetails' + ' WHERE ' + condition
      
      console.log('🔍 [GET FORM DETAIL] Query:', query);
      
      // Debug: Check what forms exist for this formID
      const debugQuery = `SELECT formID, formVersionID, formVersionNo, parentFormFolderID, locationID, projectID, inventoryItemID FROM DeviceFormDetails WHERE formID = ${formId}`;
      this.dbQuery(debugQuery, []).then((debugRes: any) => {
        if (debugRes.rows?.length > 0) {
          const formsArray = this.convertToArray(debugRes.rows);
          console.log('🔍 [GET FORM DETAIL] Debug - All forms with formID ' + formId + ':', {
            count: formsArray.length,
            forms: formsArray.map((f: any) => ({
              formID: f.formID,
              formVersionID: f.formVersionID,
              formVersionNo: f.formVersionNo,
              parentFormFolderID: f.parentFormFolderID,
              locationID: f.locationID,
              projectID: f.projectID,
              inventoryItemID: f.inventoryItemID
            }))
          });
        } else {
          console.log('🔍 [GET FORM DETAIL] Debug - No forms found with formID ' + formId);
        }
      }).catch((debugError) => {
        console.error('🔍 [GET FORM DETAIL] Debug query error:', debugError);
      });

      this.dbQuery(query, [])
        .then((res: any) => {
          console.log('🔍 [GET FORM DETAIL] Query result:', {
            rowsCount: res.rows?.length || 0,
            hasRows: res.rows?.length > 0
          });
          
          if (res.rows?.length > 0) {
            const formDetail = this.convertToObject(res.rows)
            console.log('🔍 [GET FORM DETAIL] Form detail found:', {
              formID: formDetail[0]?.formID,
              formVersionID: formDetail[0]?.formVersionID,
              formVersionNo: formDetail[0]?.formVersionNo,
              parentFormFolderID: formDetail[0]?.parentFormFolderID
            });
            
            this.getDeviceFormAttachments(formId).then((attachments: any) => {
              let formAttachments = []
              if (attachments) {
                formAttachments = attachments
              }
              console.log('✅ [GET FORM DETAIL] Resolving with form detail and attachments');
              resolve({
                formData: formDetail,
                formAttachments: formAttachments,
              })
            })
          } else {
            console.warn('⚠️ [GET FORM DETAIL] No form detail found in database for query:', query);
            resolve(null)
          }
        })
        .catch((error) => {
          console.error('❌ [GET FORM DETAIL] Query error:', error);
          reject(error)
        })
    })
  }

  getSignOffFormDetail(formId) {
    return new Promise((resolve, reject) => {
      let condition = 'formId = ' + formId

      const query = 'SELECT * FROM DeviceFormDetails' + ' WHERE ' + condition

      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            const formData = this.convertToObject(res.rows)
            this.getDeviceFormAttachments(formId).then((attachments) => {
              resolve({
                formData,
                formAttachments: attachments
                  ? attachments
                  : formData.formAttachments,
                entityList: null,
              })
            })
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getDeviceFormAttachments(formId) {
    return new Promise((resolve, reject) => {
      let condition = 'formID = ' + formId

      const query =
        'SELECT * FROM DeviceFormAttachments' + ' WHERE ' + condition

      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          resolve(null)
        })
    })
  }

  getFormBuilderDetail(formId, formVersionId, formVersionNo) {
    return new Promise((resolve, reject) => {
      let condition =
        'formId = ' +
        formId +
        ' AND formVersionId = ' +
        formVersionId +
        ' AND formVersionNo = ' +
        formVersionNo
      const query =
        'SELECT * FROM DeviceFormBuilderDetails' + ' WHERE ' + condition

      this.dbQuery(query, [])
        .then(async (res: any) => {
          if (res.rows?.length > 0) {
            const formBuilderDetail = this.convertToObject(res.rows)
            if ((!formBuilderDetail.userList || formBuilderDetail.userList.length === 0)) {
              try {
                const deviceUsers = await this.getDeviceUsers(null) as any[]
                if (deviceUsers && deviceUsers.length > 0) {
                  formBuilderDetail.userList = deviceUsers.map(user => ({
                    userId: user.userId,
                    userName: user.firstAndLastName || user.fullName || `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.userId,
                    email: user.email || '',
                    phone: user.phone || '',
                    phoneCode: user.phoneCode || ''
                  }))
                }
              } catch (error) {
                console.log('Error populating userList from device users:', error)
              }
            }
            
            resolve(formBuilderDetail)
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  getUserTotalHAVExposureForToday(userId) {
    return new Promise((resolve) => {
      const todayDate = moment().utc()

      let condition =
        'userID = "' +
        userId +
        '" AND date(modifiedDate)=date("' +
        todayDate.format('YYYY-MM-DDT00:00:00') +
        '")'
      const query =
        'SELECT SUM(exposurePoints) as total_exposure FROM DeviceUserTotalHAVExposures' +
        (condition ? ' WHERE ' + condition : '')
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          resolve(null)
        })
    })
  }

  /********************************************************************************/
  /*****************************Insert Data Operations*****************************/
  /********************************************************************************/

  insertLiveWorkPermit = (data) => {
    return new Promise((resolve, reject) => {
      this.insertData('DeviceLiveWorkPermits', data)
        .then((res: any) => {
          resolve(res.insertId)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  insertImageVideoFile = (data) => {
    return new Promise((resolve, reject) => {
      this.insertData('ImageVideoFiles', data)
        .then((res: any) => {
          resolve(res.insertId)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  insertFormSubmitData = (data) => {
    return new Promise((resolve, reject) => {
      this.insertData('FormSubmitData', data)
        .then((res: any) => {
          resolve(res.insertId)
        })
        .catch((error) => {
          reject({ message: 'Error in saving the form' })
        })
    })
  }

  insertDeviceArchivedDocuments = (data) => {
    return new Promise((resolve, reject) => {
      const entity: any = {
        inventoryItemID: data.inventoryItemID,
        locationID: data.locationID,
        projectID: data.projectID,
      }
      let condition = this.appendEntityCondition(entity)
      condition =
        condition + " AND documentTitle LIKE '%" + data.documentTitle + "%'"
      const query =
        'SELECT COUNT(*) as total_count FROM DeviceArchivedDocuments' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY createdDate DESC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            const obj = this.convertToObject(res.rows)
            if (obj.total_count > 0) {
              data.documentTitle = data.documentTitle + ' ' + obj.total_count
            }
          }
          this.insertData('DeviceArchivedDocuments', data)
            .then((res: any) => {
              resolve(res.insertId)
            })
            .catch((error) => {
              reject({ message: 'Error in saving the form: ' + (error?.message || JSON.stringify(error)) })
            })
        })
        .catch((_queryError) => {
          this.insertData('DeviceArchivedDocuments', data)
            .then((res: any) => {
              resolve(res.insertId)
            })
            .catch((error) => {
              reject({ message: 'Error in saving the form: ' + (error?.message || JSON.stringify(error)) })
            })
        })
    })
  }

  insertDeviceArchivedForms = (data) => {
    return new Promise((resolve, reject) => {
      const entity: any = {
        inventoryItemID: data.inventoryItemID,
        locationID: data.locationID,
        projectID: data.projectID,
      }
      let condition = this.appendEntityCondition(entity)
      condition =
        condition + " AND documentTitle LIKE '%" + data.documentTitle + "%'"
      const query =
        'SELECT COUNT(*) as total_count FROM DeviceArchivedForms' +
        (condition ? ' WHERE ' + condition : '') +
        ' ORDER BY createdDate DESC'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            const obj = this.convertToObject(res.rows)
            if (obj.total_count > 0) {
              data.documentTitle = data.documentTitle + ' ' + obj.total_count
            }
          }
          this.insertData('DeviceArchivedForms', data)
            .then((res: any) => {
              resolve(res.insertId)
            })
            .catch((error) => {
              reject({ message: 'Error in saving the form: ' + (error?.message || JSON.stringify(error)) })
            })
        })
        .catch((_queryError) => {
          this.insertData('DeviceArchivedForms', data)
            .then((res: any) => {
              resolve(res.insertId)
            })
            .catch((error) => {
              reject({ message: 'Error in saving the form: ' + (error?.message || JSON.stringify(error)) })
            })
        })
    })
  }

  insertHAVExposureForDate = (data) => {
    return new Promise((resolve, reject) => {
      this.insertData('DeviceUserTotalHAVExposures', data).finally(() => {
        resolve(null)
      })
    })
  }

  insertSignOffDetail = (data) => {
    return this.insertData('SignOffDetails', data)
  }

  updateSignOffDetail = (signOffDetailId: number, updates: any) => {
    return new Promise((resolve, reject) => {
      const dataCols = Object.keys(updates);
      const dataVals = Object.values(updates);
      const setClause = dataCols.map(col => `${col} = ?`).join(', ');
      const query = `UPDATE SignOffDetails SET ${setClause} WHERE signOffDetailId = ?`;
      this.dbQuery(query, [...dataVals, signOffDetailId])
        .then((res: any) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  insertCheckinDetails = async (data) => {
    // Check user qualifications and location required qualifications
    let userQualified = false
    const checkinQualifications: any = await this.getDeviceUserCheckInQualifications(
      data,
    )

    if (checkinQualifications && checkinQualifications.length > 0) {
      const userQualifications: any = await this.getDeviceUserQualifications(
        data.userId,
      )
      if (userQualifications && userQualifications.length > 0) {
        let matchedQualificationCount = 0
        checkinQualifications.map((checkinQualObj) => {
          userQualifications.some((userQualObj) => {
            if (
              checkinQualObj.qualificationID === userQualObj.qualificationID
            ) {
              if (
                userQualObj.expireDate &&
                userQualObj.expireDate !== StaticDataService.userDefaultDate &&
                userQualObj.expireDate.indexOf(
                  StaticDataService.userUnsetDate,
                ) === -1
              ) {
                if (
                  !UtilService.isExpired(
                    userQualObj.expireDate,
                    this.offlineDeviceDetailData.timeDifference,
                  )
                ) {
                  matchedQualificationCount++
                }
              } else {
                matchedQualificationCount++
              }
              return true
            }
          })
        })
        if (matchedQualificationCount === checkinQualifications.length) {
          userQualified = true
        }
      }
    } else {
      userQualified = true
    }

    return new Promise((resolve, reject) => {
      if (userQualified) {
        const {
          dataCols,
          dataVals,
          dataValPlaceHolders,
        } = this.convertObjectToColValPlaceholders(
          data,
          'DeviceUserCheckinDetails',
        )

        let query =
          'INSERT INTO DeviceUserCheckinDetails (' +
          dataCols.join(',') +
          ') select ' +
          dataValPlaceHolders.join(',') +
          ''

        this.dbQuery(query, dataVals)
          .then(async (res: any) => {
            // Insert user checkin detail to Evacuation List
            const evacuationData = {
              firstAndLastName: data.firstAndLastName || '',
              firstName: data.firstName || '',
              inventoryItemID: data.inventoryItemID || 0,
              lastName: data.lastName || '',
              locationID: data.locationID || 0,
              projectID: data.projectID || 0,
              userDetailPhoto: data.userDetailPhoto || '',
              userId: data.userId || StaticDataService.userDefaultGuid,
              userPhoto: data.userPhoto || '',
              userPhotoImageVideoFileId:
                data.userSignaturePhotoImageVideoFileId || '',
            }

            let evacCondition = {}
            if (data.inventoryItemID) {
              evacCondition['inventoryItemID'] = data.inventoryItemID
            } else if (data.locationID) {
              evacCondition['locationID'] = data.locationID
            } else if (data.projectID) {
              evacCondition['projectID'] = data.projectID
            }

            if (data.firstAndLastName) {
              evacCondition['firstAndLastName'] = data.firstAndLastName
            }
            this.insertData('DeviceEvacuations', evacuationData, evacCondition)

            resolve(res)
          })
          .catch((error) => {
            reject(error)
          })
      } else {
        const response = {
          error: {
            Version: '1.0',
            StatusCode: 402,
            Message: '',
            Result: null,
            ResponseException: {
              IsError: true,
              ExceptionMessage: {},
              Details: '',
              ReferenceErrorCode: '',
              ReferenceDocumentLink: '',
              ValidationErrors: [
                {
                  Field: 'Qualification',
                  Message: 'You do not have the required qualifications.',
                },
              ],
            },
          },
        }
        reject(response)
      }
    })
  }

  insertGuestCheckinDetails = (data) => {
    if (!data.isGuestReturning) {
      // Insert guest to the db if never checked in before
      const guestUser = {
        guestFirsName: data.guestFirsName || '',
        guestLastName: data.guestLastName || '',
        guestMiddleName: data.guestMiddleName || '',
        guestPhone: data.guestPhone || '',
        guestPhotoImageVideoFileId: data.guestPhotoImageVideoFileId || '',
        isOfflineDone: data.isOfflineDone || false,
      }

      const {
        dataCols,
        dataVals,
        dataValPlaceHolders,
      } = this.convertObjectToColValPlaceholders(guestUser, 'DeviceGuestUsers')
      let query =
        'INSERT INTO DeviceGuestUsers (' +
        dataCols.join(',') +
        ') select ' +
        dataValPlaceHolders.join(',') +
        ''

      this.dbQuery(query, dataVals)
        .then((res: any) => {})
        .catch((error) => {})
    }

    return new Promise((resolve, reject) => {
      const {
        dataCols,
        dataVals,
        dataValPlaceHolders,
      } = this.convertObjectToColValPlaceholders(
        data,
        'DeviceGuestUserCheckinDetails',
      )

      let query =
        'INSERT INTO DeviceGuestUserCheckinDetails (' +
        dataCols.join(',') +
        ') select ' +
        dataValPlaceHolders.join(',') +
        ''

      this.dbQuery(query, dataVals)
        .then(async (res: any) => {
          // Insert user checkin detail to Evacuation List
          const evacuationData = {
            firstAndLastName:
              data.guestFirsName +
              ' ' +
              (data.guestMiddleName ? data.guestMiddleName + ' ' : '') +
              data.guestLastName,
            firstName: data.guestFirsName || '',
            inventoryItemID: data.inventoryItemID || '',
            lastName: data.guestLastName || '',
            locationID: data.locationID || 0,
            projectID: data.projectID || 0,
            userDetailPhoto: data.guestPhotoFileName || '',
            userPhoto: data.guestPhotoFileName || '',
            userPhotoImageVideoFileId: data.guestPhotoImageVideoFileId || 0,
          }

          let evacCondition = {}
          if (evacuationData.inventoryItemID) {
            evacCondition['inventoryItemID'] = evacuationData.inventoryItemID
          } else if (evacuationData.locationID) {
            evacCondition['locationID'] = evacuationData.locationID
          } else if (evacuationData.projectID) {
            evacCondition['projectID'] = evacuationData.projectID
          }

          if (evacuationData.firstAndLastName) {
            evacCondition['firstAndLastName'] = evacuationData.firstAndLastName
          }
          this.insertData('DeviceEvacuations', evacuationData, evacCondition)
          resolve(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  insertCheckOutDetails = (data, cond) => {
    const userCheckInDetailID = cond.deviceUserCheckinDetailId

    return new Promise((resolve, reject) => {
      const { dataCols, dataVals } = this.convertObjectToColValPlaceholders(
        data,
        'DeviceUserCheckinDetails',
      )
      let condition = 'deviceUserCheckinDetailId = ' + userCheckInDetailID
      let query =
        'UPDATE DeviceUserCheckinDetails SET ' +
        dataCols.join(' = ?,') +
        ' = ? WHERE ' +
        condition

      this.dbQuery(query, dataVals)
        .then(async (res: any) => {
          //Get checkin details
          const checinDetailQuery =
            'SELECT * FROM DeviceUserCheckinDetails WHERE ' + condition
          // If user checkout then remove it from Evacuation list
          const checkinDetails: any = await this.dbQuery(checinDetailQuery)

          if (checkinDetails && checkinDetails.rows.length > 0) {
            const checkinDetail = this.convertToObject(checkinDetails.rows)

            let removeCondition = this.appendEntityCondition({
              inventoryItemID: checkinDetail.inventoryItemID,
              locationID: checkinDetail.locationID,
              projectID: checkinDetail.projectID,
            } as DeviceEntityDetail)

            removeCondition =
              removeCondition + ' AND userId = "' + checkinDetail.userId + '"'
            let removeQuery =
              'DELETE from DeviceEvacuations WHERE ' + removeCondition
            this.dbQuery(removeQuery).finally(() => {
              addLastCheckinDetails(checkinDetail)
            })
          } else {
            resolve(res)
          }
        })
        .catch((error) => {
          reject(error)
        })

      const addLastCheckinDetails = async (checkinDetail) => {
        const lastCheckinData = {
          checkInDate: checkinDetail.checkInDate,
          checkOutDate: checkinDetail.checkOutDate,
          showInductionSteps: false,
          todayDate: '',
          userCheckInDetailID: userCheckInDetailID,
          userId: checkinDetail.userId,
          isOfflineDone: true,
        }

        const getLastCheckinDetail: any = await this.getDeviceUserLastCheckinDetail(
          checkinDetail,
          checkinDetail.userId,
          false,
        )
        if (getLastCheckinDetail) {
          if (checkinDetail.processInductionsteps) {
            const {
              dataCols,
              dataVals,
            } = this.convertObjectToColValPlaceholders(
              lastCheckinData,
              'DeviceUserLastCheckinDetailList',
            )
            let condition =
              'deviceUserLastCheckinDetailId = ' +
              getLastCheckinDetail.deviceUserLastCheckinDetailId
            let query =
              'UPDATE DeviceUserLastCheckinDetailList SET ' +
              dataCols.join(' = ?,') +
              ' = ? WHERE ' +
              condition
            this.dbQuery(query, dataVals).finally(() => {
              resolve(checkinDetail)
            })
          } else {
            resolve(checkinDetail)
          }
        } else {
          if (checkinDetail.inventoryItemID) {
            lastCheckinData['inventoryItemID'] = checkinDetail.inventoryItemID
          } else if (checkinDetail.locationID) {
            lastCheckinData['locationID'] = checkinDetail.locationID
          } else if (checkinDetail.projectID) {
            lastCheckinData['projectID'] = checkinDetail.projectID
          }

          this.insertData(
            'DeviceUserLastCheckinDetailList',
            lastCheckinData,
          ).finally(() => {
            resolve(checkinDetail)
          })
        }
      }
    })
  }

  insertCheckOutDetails_Guest = (data, cond: any = {}) => {
    const deviceGuestUserCheckinDetailId = cond.deviceGuestUserCheckinDetailId

    return new Promise((resolve, reject) => {
      const { dataCols, dataVals } = this.convertObjectToColValPlaceholders(
        data,
        'DeviceGuestUserCheckinDetails',
      )
      let condition =
        'deviceGuestUserCheckinDetailId = ' + deviceGuestUserCheckinDetailId
      let query =
        'UPDATE DeviceGuestUserCheckinDetails SET ' +
        dataCols.join(' = ?,') +
        ' = ? WHERE ' +
        condition

      this.dbQuery(query, dataVals)
        .then(async (res: any) => {
          console.log('[CHECKOUT-SYNC] insertCheckOutDetails_Guest | UPDATE rowsAffected:', res?.rowsAffected, '| id:', deviceGuestUserCheckinDetailId)
          //Get checkin details
          const checinDetailQuery =
            'SELECT * FROM DeviceGuestUserCheckinDetails WHERE ' + condition
          // If user checkout then remove it from Evacuation list
          const checkinDetails: any = await this.dbQuery(checinDetailQuery)

          console.log('[CHECKOUT-SYNC] post-UPDATE SELECT | rows:', checkinDetails?.rows?.length ?? 0, '| isOfflineDone:', checkinDetails?.rows?.length > 0 ? this.convertToObject(checkinDetails.rows)?.isOfflineDone : 'N/A')

          if (checkinDetails && checkinDetails.rows.length > 0) {
            const checkinDetail = this.convertToObject(checkinDetails.rows)

            let removeCondition = this.appendEntityCondition({
              inventoryItemID: checkinDetail.inventoryItemID,
              locationID: checkinDetail.locationID,
              projectID: checkinDetail.projectID,
            } as DeviceEntityDetail)

            const firstAndLastName =
              checkinDetail.guestFirsName +
              ' ' +
              (checkinDetail.guestMiddleName
                ? checkinDetail.guestMiddleName + ' '
                : '') +
              checkinDetail.guestLastName
            removeCondition =
              removeCondition +
              ' AND firstAndLastName = "' +
              firstAndLastName +
              '"'
            let removeQuery =
              'DELETE from DeviceEvacuations WHERE ' + removeCondition
            this.dbQuery(removeQuery)
              .then((delRes: any) => {
                console.log('[EVAC] evacuation:delete | name:', firstAndLastName, '| rowsAffected:', delRes?.rowsAffected)
              })
              .finally(() => {
                addLastCheckinDetails(checkinDetail)
              })
          } else {
            resolve(res)
          }
        })
        .catch((error) => {
          reject(error)
        })

      const addLastCheckinDetails = async (checkinDetail) => {
        const lastCheckinData = {
          guestFirsName: checkinDetail.guestFirsName,
          guestLastName: checkinDetail.guestLastName,
          guestMiddleName: checkinDetail.guestMiddleName,
          guestPhone: checkinDetail.guestPhone.toString(),
          checkInDate: checkinDetail.checkInDate,
          checkOutDate: checkinDetail.checkOutDate,
          showInductionSteps: false,
          todayDate: '',
          userCheckInDetailID: deviceGuestUserCheckinDetailId,
          isOfflineDone: true,
        }

        const getLastCheckinDetail: any = await this.getDeviceUserLastCheckinDetail(
          checkinDetail,
          checkinDetail.guestPhone.toString(),
          true,
        )
        if (getLastCheckinDetail) {
          if (checkinDetail.processInductionsteps) {
            const {
              dataCols,
              dataVals,
            } = this.convertObjectToColValPlaceholders(
              lastCheckinData,
              'DeviceGuestUserLastCheckinDetailList',
            )
            let condition =
              'deviceGuestUserLastCheckinDetailId = ' +
              getLastCheckinDetail.deviceGuestUserLastCheckinDetailId
            let query =
              'UPDATE DeviceGuestUserLastCheckinDetailList SET ' +
              dataCols.join(' = ?,') +
              ' = ? WHERE ' +
              condition
            this.dbQuery(query, dataVals).finally(() => {
              resolve(checkinDetail)
            })
          } else {
            resolve(checkinDetail)
          }
        } else {
          if (checkinDetail.inventoryItemID) {
            lastCheckinData['inventoryItemID'] = checkinDetail.inventoryItemID
          } else if (checkinDetail.locationID) {
            lastCheckinData['locationID'] = checkinDetail.locationID
          } else if (checkinDetail.projectID) {
            lastCheckinData['projectID'] = checkinDetail.projectID
          }

          this.insertData(
            'DeviceGuestUserLastCheckinDetailList',
            lastCheckinData,
          ).finally(() => {
            resolve(checkinDetail)
          })
        }
      }
    })
  }

  /********************************************************************************/
  /*****************************Get Offline Data For Post**************************/
  /********************************************************************************/

  shouldOnlyUseInOfflineMode = () => {
    const signOffQuery =
      'SELECT COUNT(signOffDetailId) as total_result FROM SignOffDetails'
    const checkinQuery =
      'SELECT COUNT(deviceUserCheckinDetailId)  as total_result FROM DeviceUserCheckinDetails WHERE isOfflineDone = true OR isOfflineDone = "true"'
    const guestCheckinQuery =
      'SELECT COUNT(deviceGuestUserCheckinDetailId)  as total_result FROM DeviceGuestUserCheckinDetails WHERE isOfflineDone = true OR isOfflineDone = "true"'

    return new Promise((resolve) => {
      this.dbQuery(signOffQuery)
        .then((res: any) => {
          const signOffRes = this.convertToObject(res.rows)
          if (signOffRes && signOffRes.total_result > 0) {
            resolve(true)
          } else {
            this.dbQuery(checkinQuery)
              .then((res1: any) => {
                const checkinRes = this.convertToObject(res1.rows)
                if (checkinRes && checkinRes.total_result > 0) {
                  resolve(true)
                } else {
                  this.dbQuery(guestCheckinQuery)
                    .then((res2: any) => {
                      const guestCheckinRes = this.convertToObject(res2.rows)
                      if (guestCheckinRes && guestCheckinRes.total_result > 0) {
                        resolve(true)
                      } else {
                        resolve(false)
                      }
                    })
                    .catch((error) => {
                      resolve(false)
                    })
                }
              })
              .catch((error) => {
                resolve(false)
              })
          }
        })
        .catch((error) => {})
    })
  }

  getAllFormSubmittedFiles = () => {
    return new Promise((resolve) => {
      const query = 'SELECT * FROM ImageVideoFiles'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getOfflineSubmittedFormData = (formSubmitDataId) => {
    return new Promise((resolve) => {
      const query =
        'SELECT * FROM FormSubmitData WHERE formSubmitDataId = ' +
        formSubmitDataId
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToObject(res.rows))
          } else {
            resolve(null)
          }
        })
        .catch((error) => {
          resolve(null)
        })
    })
  }

  getOfflineSignoffDetails = () => {
    return new Promise((resolve) => {
      const query = 'SELECT * FROM SignOffDetails'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getOfflineUserCheckinDetails = () => {
    return new Promise((resolve) => {
      const query =
        'SELECT * FROM DeviceUserCheckinDetails WHERE ' +
        this.emptyCond('userCheckInDetailID') +
        ' AND (isOfflineDone = true OR isOfflineDone = "true")'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getOfflineGuestCheckinDetails = () => {
    return new Promise((resolve) => {
      const query =
        // Include CI-only rows AND CI+CO paired rows where the CI hasn't been synced yet
        // (userCheckInDetailID is null/empty = no server ID assigned yet).
        // Excludes CO-only rows (checkOutDate set + server ID already present).
        'SELECT * FROM DeviceGuestUserCheckinDetails WHERE (isOfflineDone = true OR isOfflineDone = "true") AND (checkOutDate IS NULL OR checkOutDate = "" OR checkOutDate = "0001-01-01T00:00:00" OR userCheckInDetailID IS NULL OR userCheckInDetailID = "" OR userCheckInDetailID = "0" OR userCheckInDetailID = 0)'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getOfflineUserCheckoutDetails = () => {
    return new Promise((resolve) => {
      const query =
        'SELECT * FROM DeviceUserCheckinDetails WHERE (isOfflineDone = true OR isOfflineDone = "true")  AND (checkOutDate IS NOT NULL AND checkOutDate != "" AND checkOutDate != "' +
        StaticDataService.userDefaultDate +
        '")'
      this.dbQuery(query, [])
        .then((res: any) => {
          if (res.rows?.length > 0) {
            resolve(this.convertToArray(res.rows))
          } else {
            resolve([])
          }
        })
        .catch((error) => {
          resolve([])
        })
    })
  }

  getOfflineGuestCheckoutDetails = () => {
    return new Promise((resolve) => {
      const query =
        'SELECT * FROM DeviceGuestUserCheckinDetails WHERE (isOfflineDone = true OR isOfflineDone = "true") AND (checkOutDate IS NOT NULL AND checkOutDate != "" AND checkOutDate != "' +
        StaticDataService.userDefaultDate +
        '")'
      this.dbQuery(query, [])
        .then((res: any) => {
          const rows = res.rows?.length > 0 ? this.convertToArray(res.rows) : []
          console.log('[CHECKOUT-SYNC] getOfflineGuestCheckoutDetails | count:', rows.length, '| rows:', rows.map((r: any) => ({ id: r.deviceGuestUserCheckinDetailId, phone: r.guestPhone, isOfflineDone: r.isOfflineDone, checkOutDate: r.checkOutDate })))
          if (rows.length > 0) {
            resolve(rows)
          } else {
            resolve([])
          }
        })
        .catch(() => {
          resolve([])
        })
    })
  }

  replaceImageNameInFormData = (submittedFormData, uploadedFiles) => {
    console.log('🔄 [REPLACE IMAGE NAME] Starting replaceImageNameInFormData');
    console.log('🔄 [REPLACE IMAGE NAME] uploadedFiles keys:', Object.keys(uploadedFiles));
    console.log('🔄 [REPLACE IMAGE NAME] uploadedFiles:', uploadedFiles);
    
    if (submittedFormData) {
      try {
        submittedFormData.formattedSections?.map((section, sectionIndex) => {
          section.answerData?.map((questionAsnwerObj, answerIndex) => {
            if (section.isAccidentReportSection) {
              if (questionAsnwerObj.answerData?.accidentAttachmentFileId) {
                const fileId = questionAsnwerObj.answerData.accidentAttachmentFileId;
                console.log(`🔄 [REPLACE IMAGE NAME] Found accidentAttachmentFileId in formattedSections[${sectionIndex}].answerData[${answerIndex}]:`, fileId, 'type:', typeof fileId);
                
                // Handle comma-separated file IDs
                if (typeof fileId === 'string' && fileId.includes(',')) {
                  const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
                  console.log(`🔄 [REPLACE IMAGE NAME] Splitting comma-separated accidentAttachmentFileIds:`, fileIds);
                  const fileNames = fileIds.map(id => {
                    const lookupKey = 'imageVideoFileId_' + id;
                    const fileName = uploadedFiles[lookupKey];
                    console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                    return fileName;
                  }).filter(name => name).join(',');
                  console.log(`🔄 [REPLACE IMAGE NAME] Combined file names:`, fileNames);
                  questionAsnwerObj.answerData['accidentAttachmentFileName'] = fileNames;
                } else {
                  const lookupKey = 'imageVideoFileId_' + fileId;
                  const fileName = uploadedFiles[lookupKey];
                  console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                  questionAsnwerObj.answerData['accidentAttachmentFileName'] = fileName;
                }

                delete questionAsnwerObj.answerData.accidentAttachmentFileId
              }
              if (questionAsnwerObj.arAnswerData?.accidentAttachmentFileId) {
                const fileId = questionAsnwerObj.arAnswerData.accidentAttachmentFileId;
                console.log(`🔄 [REPLACE IMAGE NAME] Found accidentAttachmentFileId in arAnswerData:`, fileId);
                
                // Handle comma-separated file IDs
                if (typeof fileId === 'string' && fileId.includes(',')) {
                  const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
                  const fileNames = fileIds.map(id => {
                    const lookupKey = 'imageVideoFileId_' + id;
                    return uploadedFiles[lookupKey];
                  }).filter(name => name).join(',');
                  questionAsnwerObj.arAnswerData['accidentAttachmentFileName'] = fileNames;
                } else {
                  questionAsnwerObj.arAnswerData['accidentAttachmentFileName'] =
                    uploadedFiles[
                      'imageVideoFileId_' +
                        questionAsnwerObj.arAnswerData.accidentAttachmentFileId
                    ];
                }
                delete questionAsnwerObj.arAnswerData.accidentAttachmentFileId
              }
            } else {
              if (questionAsnwerObj.answerData?.imageVideoFileId) {
                const fileId = questionAsnwerObj.answerData.imageVideoFileId;
                console.log(`🔄 [REPLACE IMAGE NAME] Found imageVideoFileId in formattedSections[${sectionIndex}].answerData[${answerIndex}]:`, fileId, 'type:', typeof fileId);
                
                // Handle comma-separated file IDs
                if (typeof fileId === 'string' && fileId.includes(',')) {
                  const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
                  console.log(`🔄 [REPLACE IMAGE NAME] Splitting comma-separated imageVideoFileIds:`, fileIds);
                  const fileNames = fileIds.map(id => {
                    const lookupKey = 'imageVideoFileId_' + id;
                    const fileName = uploadedFiles[lookupKey];
                    console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                    return fileName;
                  }).filter(name => name).join(',');
                  console.log(`🔄 [REPLACE IMAGE NAME] Combined file names:`, fileNames);
                  questionAsnwerObj.answerData['imageVideoFileName'] = fileNames;
                } else {
                  const lookupKey = 'imageVideoFileId_' + fileId;
                  const fileName = uploadedFiles[lookupKey];
                  console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                  questionAsnwerObj.answerData['imageVideoFileName'] = fileName;
                }
                delete questionAsnwerObj.answerData.imageVideoFileId
              }
            }
          })
        })
      } catch (error) {
        console.error('❌ [REPLACE IMAGE NAME] Error in replaceImageNameInFormData:', error);
      }

      try {
        submittedFormData.accidentReportQuestionAnswers?.map(
          (questionAsnwerObj, index) => {
            if (questionAsnwerObj.accidentAttachmentFileId) {
              const fileId = questionAsnwerObj.accidentAttachmentFileId;
              console.log(`🔄 [REPLACE IMAGE NAME] Found accidentAttachmentFileId in accidentReportQuestionAnswers[${index}]:`, fileId, 'type:', typeof fileId);
              
              // Handle comma-separated file IDs
              if (typeof fileId === 'string' && fileId.includes(',')) {
                const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
                console.log(`🔄 [REPLACE IMAGE NAME] Splitting comma-separated accidentAttachmentFileIds:`, fileIds);
                const fileNames = fileIds.map(id => {
                  const lookupKey = 'imageVideoFileId_' + id;
                  const fileName = uploadedFiles[lookupKey];
                  console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                  return fileName;
                }).filter(name => name).join(',');
                console.log(`🔄 [REPLACE IMAGE NAME] Combined file names:`, fileNames);
                questionAsnwerObj['accidentAttachmentFileName'] = fileNames;
              } else {
                const lookupKey = 'imageVideoFileId_' + fileId;
                const fileName = uploadedFiles[lookupKey];
                console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                questionAsnwerObj['accidentAttachmentFileName'] = fileName;
              }
              delete questionAsnwerObj.accidentAttachmentFileId
            }
          },
        )
      } catch (error) {
        console.error('❌ [REPLACE IMAGE NAME] Error processing accidentReportQuestionAnswers:', error);
      }

      try {
        submittedFormData.questionAnswers?.map((questionAsnwerObj, index) => {
          if (questionAsnwerObj.imageVideoFileId) {
            const fileId = questionAsnwerObj.imageVideoFileId;
            console.log(`🔄 [REPLACE IMAGE NAME] Found imageVideoFileId in questionAnswers[${index}]:`, fileId, 'type:', typeof fileId);
            
            // Handle comma-separated file IDs
            if (typeof fileId === 'string' && fileId.includes(',')) {
              const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
              console.log(`🔄 [REPLACE IMAGE NAME] Splitting comma-separated imageVideoFileIds:`, fileIds);
              const fileNames = fileIds.map(id => {
                const lookupKey = 'imageVideoFileId_' + id;
                const fileName = uploadedFiles[lookupKey];
                console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                return fileName;
              }).filter(name => name).join(',');
              console.log(`🔄 [REPLACE IMAGE NAME] Combined file names:`, fileNames);
              questionAsnwerObj['imageVideoFileName'] = fileNames;
            } else {
              const lookupKey = 'imageVideoFileId_' + fileId;
              const fileName = uploadedFiles[lookupKey];
              console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
              questionAsnwerObj['imageVideoFileName'] = fileName;
            }
            delete questionAsnwerObj.imageVideoFileId
          }
          if (questionAsnwerObj.accidentAttachmentFileId) {
            const fileId = questionAsnwerObj.accidentAttachmentFileId;
            console.log(`🔄 [REPLACE IMAGE NAME] Found accidentAttachmentFileId in questionAnswers[${index}]:`, fileId, 'type:', typeof fileId);
            
            // Handle comma-separated file IDs
            if (typeof fileId === 'string' && fileId.includes(',')) {
              const fileIds = fileId.split(',').map(id => id.trim()).filter(id => id);
              console.log(`🔄 [REPLACE IMAGE NAME] Splitting comma-separated accidentAttachmentFileIds:`, fileIds);
              const fileNames = fileIds.map(id => {
                const lookupKey = 'imageVideoFileId_' + id;
                const fileName = uploadedFiles[lookupKey];
                console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
                return fileName;
              }).filter(name => name).join(',');
              console.log(`🔄 [REPLACE IMAGE NAME] Combined file names:`, fileNames);
              questionAsnwerObj['accidentAttachmentFileName'] = fileNames;
            } else {
              const lookupKey = 'imageVideoFileId_' + fileId;
              const fileName = uploadedFiles[lookupKey];
              console.log(`🔄 [REPLACE IMAGE NAME] Looking up ${lookupKey}:`, fileName);
              questionAsnwerObj['accidentAttachmentFileName'] = fileName;
            }
            delete questionAsnwerObj.accidentAttachmentFileId
          }
        })
      } catch (error) {}
    }
  }

  async prepareJsonFileForPost(deviceId, offlineApiService) {
    let postJsonFileData = {
      deviceID: deviceId,
      personalModeSignOffDetails: [],
      checkInDetails: [],
      checkInDetails_Guest: [],
      checkOutDetails: [],
      checkOutDetails_Guest: [],
    }
    let isDataAvailableForPost = false

    return new Promise(async (resolve, reject) => {
      const uploadAllFormOfflineFile = async () => {
        // getAllFormSubmittedFiles
        const allFiles: any = await this.getAllFormSubmittedFiles()

        if (allFiles && allFiles.length > 0) {
          let convertedFileCount = 0
          const formData = new FormData()
          allFiles.forEach(async (fileData: any) => {
            const offlineFileName = fileData.fileName
            const offlineFileDirectory =
              this.filehandlerService.offlineFilesDirectory() +
              StaticDataService.offlineFilesFolderName +
              '/' +
              offlineFileName

            const response = await fetch(
              Capacitor.convertFileSrc(offlineFileDirectory),
            )
            const blob = await response.blob()
            formData.append(
              'files',
              blob,
              fileData.imageVideoFileId + '|' + offlineFileName,
            )
            convertedFileCount++
            if (convertedFileCount === allFiles.length) {
              onAllBinaryToFileCoverted(formData)
            }

            // this.utilService
            //   .dataUriToFile(
            //     fileData.binaryFile,
            //     fileData.fileName,
            //     fileData.mimeType
            //   )
            //   .then((fileObj: any) => {
            //     if (fileObj) {
            //       formData.append(
            //         "files",
            //         fileObj,
            //         fileData.imageVideoFileId + "|" + fileData.fileName
            //       );
            //     }
            //     convertedFileCount++;
            //     if (convertedFileCount === allFiles.length) {
            //       onAllBinaryToFileCoverted(formData);
            //     }
            //   });
          })
        } else {
          getSignOffDetails()
        }
      }

      // Get all offline files for submitted form and
      const onAllBinaryToFileCoverted = (formData) => {
        offlineApiService.uploadMultipleFiles(formData).subscribe(
          (response: any) => {
            if (response.Result) {
              const uploadedFiles = response.Result
              let uploadedFilesObj = {}
              if (uploadedFiles) {
                uploadedFiles.map((uploadedFileData) => {
                  const originalFileName = uploadedFileData.originalFileName
                  const newFileName = uploadedFileData.newFileName

                  const originalFileNameParts = originalFileName.split('|')
                  if (
                    originalFileNameParts &&
                    originalFileNameParts.length > 0
                  ) {
                    const imageVideoFileId = originalFileNameParts[0]
                    uploadedFilesObj[
                      'imageVideoFileId_' + imageVideoFileId
                    ] = newFileName
                  }
                })
              }

              getSignOffDetails(uploadedFilesObj)
            } else {
              getSignOffDetails()
            }
          },
          (error) => {},
        )
      }

      // getSignOffDetails
      const getSignOffDetails = async (uploadedFiles = {}) => {
        const signOffDetails: any = await this.getOfflineSignoffDetails()

        let signOffDetailsList = []

        if (signOffDetails && signOffDetails.length > 0) {
          const addToSignOffDetailsList = (dataObj) => {
            const signOffObjectToBePost = {
              userId: dataObj.userId || '',
              activityIndividualID: dataObj.activityIndividualID || '',
              documentVersionID: dataObj.documentVersionID || '',
              formVersionID: dataObj.formVersionID || 0,
              locationID: dataObj.locationID || 0,
              projectID: dataObj.projectID || 0,
              inventoryItemID: dataObj.inventoryItemID || 0,
              latitude: dataObj.latitude || '',
              longitude: dataObj.longitude || '',
              documentID: dataObj.documentID || 0,
              userSignaturePhotoFileName:
                uploadedFiles[
                  'imageVideoFileId_' +
                    dataObj.userSignaturePhotoImageVideoFileId
                ] || '',
              userSignaturePhotoBinaryFile: '',
              userSignaturePhoto:
                uploadedFiles[
                  'imageVideoFileId_' +
                    dataObj.userSignaturePhotoImageVideoFileId
                ] || '',
              digitalInkSignatureFileName:
                uploadedFiles[
                  'imageVideoFileId_' +
                    dataObj.digitalInkSignatureImageVideoFileId
                ] || '',
              digitalInkSignatureBinaryFile: '',
              digitalInkSignature:
                uploadedFiles[
                  'imageVideoFileId_' +
                    dataObj.digitalInkSignatureImageVideoFileId
                ] || '',
              formAnswerData: dataObj.submittedFormData || '',
              signOffDate: dataObj.signOffDate || '',
            }
            signOffDetailsList.push(signOffObjectToBePost)

            if (signOffDetailsList.length === signOffDetails.length) {
              postJsonFileData.personalModeSignOffDetails = signOffDetailsList
              isDataAvailableForPost = true
              getUserCheckinDetails(uploadedFiles)
            }
          }

          for (const dataObj of signOffDetails) {
            if (dataObj.formSubmitDataId) {
              const submittedFormData: any = await this.getOfflineSubmittedFormData(
                dataObj.formSubmitDataId
              )
              this.replaceImageNameInFormData(submittedFormData, uploadedFiles)
              // Remove workPermitAnswer and workPermitDetails for non-permit forms
              // Only include these fields for permit forms (formTypeId === 3)
              if (submittedFormData) {
                const isWorkPermitForm = submittedFormData.formTypeId === 3
                if (!isWorkPermitForm) {
                  delete submittedFormData.workPermitAnswer
                  delete submittedFormData.workPermitDetails
                }
              }
              dataObj.submittedFormData = submittedFormData
              await addToSignOffDetailsList(dataObj)
            } else {
              await addToSignOffDetailsList(dataObj)
            }
          }
        } else {
          getUserCheckinDetails(uploadedFiles)
        }
      }

      // getUserCheckinDetails
      const getUserCheckinDetails = async (uploadedFiles) => {
        const checkinDetails: any = await this.getOfflineUserCheckinDetails()
        console.log(`🔍 [PREPARE-JSON] getOfflineUserCheckinDetails returned: ${checkinDetails?.length ?? 'null'}`, (checkinDetails || []).map((r: any) => ({ deviceUserCheckinDetailId: r.deviceUserCheckinDetailId, userId: r.userId, userCheckInDetailID: r.userCheckInDetailID, isOfflineDone: r.isOfflineDone, checkInDate: r.checkInDate, checkOutDate: r.checkOutDate })));

        if (checkinDetails && checkinDetails.length > 0) {
          let checkinDetailsList = []

          const addToCheckinDetailList = (obj) => {
            checkinDetailsList.push({
              userId: obj?.userId || '',
              companyID: obj?.companyID || 0,
              userPhotoFileName: '',
              userPhotoBinaryFile: '',
              userPhoto:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userPhotoImageVideoFileId
                ] || '',
              locationID: obj?.locationID || 0,
              projectID: obj?.projectID || '',
              inventoryItemID: obj?.inventoryItemID || '',
              checkInLatitude: obj?.checkInLatitude || '',
              checkInLongitude: obj?.checkInLongitude || '',
              digitalInkSignatureFileName:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.digitalInkSignatureImageVideoFileId
                ] || '',
              digitalInkSignatureBinaryFile: '',
              digitalInkSignature:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.digitalInkSignatureImageVideoFileId
                ] || '',
              userSignaturePhotoFileName:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userSignaturePhotoImageVideoFileId
                ] || '',
              userSignaturePhotoBinaryFile: '',
              userSignaturePhoto:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userSignaturePhotoImageVideoFileId
                ] || '',
              checkInDate: obj?.checkInDate || '',
              formAnswerData: obj?.formAnswerData || [],
              offlineUserCheckInDetailID: obj?.deviceUserCheckinDetailId,
              processInductionsteps: obj?.processInductionsteps,
            })
            if (checkinDetails.length === checkinDetailsList.length) {
              postJsonFileData.checkInDetails = checkinDetailsList
              isDataAvailableForPost = true
              getGuestCheckinDetails(uploadedFiles)
            }
          }

          checkinDetails.map((checkinDetailObj?) => {
            if (
              checkinDetailObj?.formSubmitDataId &&
              checkinDetailObj?.formSubmitDataId.length > 0
            ) {
              let countSubmittedForm = 0
              checkinDetailObj?.formSubmitDataId.forEach((formSubmitDataId) => {
                this.getOfflineSubmittedFormData(formSubmitDataId).then(
                  (submittedFormData: any) => {
                    this.replaceImageNameInFormData(
                      submittedFormData,
                      uploadedFiles,
                    )
                    if (
                      !checkinDetailObj?.formAnswerData ||
                      !Array.isArray(checkinDetailObj?.formAnswerData)
                    ) {
                      checkinDetailObj.formAnswerData = []
                    }
                    checkinDetailObj?.formAnswerData.push(submittedFormData)

                    countSubmittedForm++
                    if (
                      checkinDetailObj?.formSubmitDataId.length ===
                      countSubmittedForm
                    ) {
                      addToCheckinDetailList(checkinDetailObj)
                    }
                  },
                )
              })
            } else {
              addToCheckinDetailList(checkinDetailObj)
            }
          })
        } else {
          getGuestCheckinDetails(uploadedFiles)
        }
      }

      // getGuestCheckinDetails
      const getGuestCheckinDetails = async (uploadedFiles) => {
        const checkinDetails: any = await this.getOfflineGuestCheckinDetails()

        if (checkinDetails && checkinDetails.length > 0) {
          let checkinDetailsList = []

          const addToCheckinDetailList = (obj) => {
            checkinDetailsList.push({
              companyID: obj?.companyID || 0,
              userPhotoFileName: '',
              userPhotoBinaryFile: '',
              userPhoto:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userPhotoImageVideoFileId
                ] || '',
              locationID: obj?.locationID || 0,
              projectID: obj?.projectID || 0,
              inventoryItemID: obj?.inventoryItemID || 0,
              checkInLatitude: obj?.checkInLatitude || '',
              checkInLongitude: obj?.checkInLongitude || '',
              isGuestReturning: obj?.isGuestReturning || false,
              guestPhone: obj?.guestPhone || '',
              guestFirsName: obj?.guestFirsName || '',
              guestMiddleName: obj?.guestMiddleName || '',
              guestLastName: obj?.guestLastName || '',
              guestPhotoFileName:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.guestPhotoImageVideoFileId
                ] || '',
              guestPhotoBinaryFile: '',
              guestPhoto:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.guestPhotoImageVideoFileId
                ] || '',
              digitalInkSignatureFileName:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.digitalInkSignatureImageVideoFileId
                ] || '',
              digitalInkSignatureBinaryFile: '',
              digitalInkSignature:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.digitalInkSignatureImageVideoFileId
                ] || '',
              userSignaturePhotoFileName:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userSignaturePhotoImageVideoFileId
                ] || '',
              userSignaturePhotoBinaryFile: '',
              userSignaturePhoto:
                uploadedFiles[
                  'imageVideoFileId_' + obj?.userSignaturePhotoImageVideoFileId
                ] || '',
              checkInDate: obj?.checkInDate || '',
              formAnswerData: obj?.formAnswerData || '',
              offlineUserCheckInDetailID: obj?.deviceGuestUserCheckinDetailId,
              processInductionsteps: obj?.processInductionsteps,
            })
            if (checkinDetails.length === checkinDetailsList.length) {
              postJsonFileData.checkInDetails_Guest = checkinDetailsList
              isDataAvailableForPost = true
              getUserCheckoutDetails()
            }
          }

          checkinDetails.map((checkinDetailObj) => {
            if (
              checkinDetailObj.formSubmitDataId &&
              checkinDetailObj.formSubmitDataId.length > 0
            ) {
              let countSubmittedForm = 0
              checkinDetailObj.formSubmitDataId.forEach((formSubmitDataId) => {
                this.getOfflineSubmittedFormData(formSubmitDataId).then(
                  (submittedFormData: any) => {
                    this.replaceImageNameInFormData(
                      submittedFormData,
                      uploadedFiles,
                    )
                    // Remove workPermitAnswer and workPermitDetails for non-permit forms
                    // Only include these fields for permit forms (formTypeId === 3)
                    if (submittedFormData) {
                      const isWorkPermitForm = submittedFormData.formTypeId === 3
                      if (!isWorkPermitForm) {
                        delete submittedFormData.workPermitAnswer
                        delete submittedFormData.workPermitDetails
                      }
                    }
                    if (
                      !checkinDetailObj.formAnswerData ||
                      !Array.isArray(checkinDetailObj.formAnswerData)
                    ) {
                      checkinDetailObj.formAnswerData = []
                    }
                    checkinDetailObj.formAnswerData.push(submittedFormData)

                    countSubmittedForm++
                    if (
                      checkinDetailObj.formSubmitDataId.length ===
                      countSubmittedForm
                    ) {
                      addToCheckinDetailList(checkinDetailObj)
                    }
                  },
                )
              })
            } else {
              addToCheckinDetailList(checkinDetailObj)
            }
          })
        } else {
          getUserCheckoutDetails()
        }
      }

      // getUserCheckoutDetails
      const getUserCheckoutDetails = async () => {
        const checkoutDetails: any = await this.getOfflineUserCheckoutDetails()
        if (checkoutDetails && checkoutDetails.length > 0) {
          let checkoutDetailsList = []
          checkoutDetails.map((obj) => {
            checkoutDetailsList.push({
              userCheckInDetailID: obj.userCheckInDetailID || 0,
              userId: obj.userId || '',
              companyID: obj?.companyID || 0,
              checkOutLatitude: obj.checkOutLatitude || '',
              checkOutLongitude: obj.checkOutLongitude || '',
              checkOutDate: obj.checkOutDate || '',
              locationID: obj.locationID || 0,
              projectID: obj.projectID || 0,
              inventoryItemID: obj.inventoryItemID || 0,
              offlineUserCheckInDetailID: obj.deviceUserCheckinDetailId,
            })
          })
          postJsonFileData.checkOutDetails = checkoutDetailsList
          isDataAvailableForPost = true
          getGuestCheckoutDetails()
        } else {
          getGuestCheckoutDetails()
        }
      }

      // getGuestCheckoutDetails
      const getGuestCheckoutDetails = async () => {
        const checkoutDetails: any = await this.getOfflineGuestCheckoutDetails()

        if (checkoutDetails && checkoutDetails.length > 0) {
          let checkoutDetailsList = []
          checkoutDetails.map((obj) => {
            checkoutDetailsList.push({
              userCheckInDetailID: obj.userCheckInDetailID || 0,
              locationID: obj.locationID || 0,
              projectID: obj.projectID || 0,
              inventoryItemID: obj.inventoryItemID || 0,
              userId: obj.userId || '',
              companyID: obj?.companyID || 0,
              guestPhone: obj.guestPhone || '',
              guestFirsName: obj.guestFirsName || '',
              guestMiddleName: obj.guestMiddleName || '',
              guestLastName: obj.guestLastName || '',
              checkOutLatitude: obj.checkOutLatitude || '',
              checkOutLongitude: obj.checkOutLongitude || '',
              checkOutDate: obj.checkOutDate || '',
              offlineUserCheckInDetailID: obj.deviceGuestUserCheckinDetailId,
            })
          })
          postJsonFileData.checkOutDetails_Guest = checkoutDetailsList
          isDataAvailableForPost = true
          onJsonFileDataInsertionComplete()
        } else {
          onJsonFileDataInsertionComplete()
        }
      }

      // When all operation done for offline json file post insertion
      const onJsonFileDataInsertionComplete = () => {
        if (isDataAvailableForPost) {
          resolve(postJsonFileData)
        } else {
          resolve(null)
        }
      }

      uploadAllFormOfflineFile()
    })
  }

  /**
   * Download document PDF file from documentDownloadUrl and save it locally for offline access
   * @param forceDownload - If true, delete existing file before downloading (for updated documents)
   */
  private async downloadDocumentFile(
    documentDownloadUrl: string,
    documentFileName: string,
    forceDownload: boolean = false,
    subfolder: 'document' | 'images' = 'document'
  ): Promise<void> {
    // Skip download for web apps
    if (UtilService.isWebApp() || environment.isFormPreview) {
      return;
    }

    try {
      // Get the offline files directory structure (same as getOfflineFileUrl uses)
      // Use this.file.dataDirectory to match getOfflineFileUrl exactly
      const writeDirectory = this.file.dataDirectory;
      const offlineFilesFolderName = localStorage.getItem(
        EnumService.LocalStorageKeys.OFFLINE_FILES_FOLDER_NAME
      ) || StaticDataService.offlineFilesFolderName;

      // Create base folder if it doesn't exist
      try {
        await this.file.createDir(writeDirectory, offlineFilesFolderName, false);
      } catch (error) {
        // Folder might already exist, ignore
      }
      
      // Create subfolder if it doesn't exist (document/ or images/)
      // Use the same path construction as getOfflineFileUrl
      const baseFolderPath = `${writeDirectory}${offlineFilesFolderName}`;
      try {
        await this.file.createDir(baseFolderPath, subfolder, false);
      } catch (error) {
        // Folder might already exist, ignore
      }

      // Construct the file path exactly as getOfflineFileUrl does
      // getOfflineFileUrl uses: deviceDirectory + offlineFilesFolderName + slash + subfolder + slash + fileName
      let documentFolderPath = `${baseFolderPath}/${subfolder}`;
      const localFilePath = `${documentFolderPath}/${documentFileName}`;
      
      // Remove file:// prefix for file system operations (file.checkFile expects raw paths)
      const documentFolderPathForCheck = documentFolderPath.replace(/^file:\/\//, '');
      
      const expectedPathForOpening = `${writeDirectory}${offlineFilesFolderName}/${subfolder}/${documentFileName}`;
      console.log(`📁 [DOWNLOAD] Path construction:`);
      console.log(`📁 [DOWNLOAD] writeDirectory: ${writeDirectory}`);
      console.log(`📁 [DOWNLOAD] offlineFilesFolderName: ${offlineFilesFolderName}`);
      console.log(`📁 [DOWNLOAD] documentFolderPath (with file://): ${documentFolderPath}`);
      console.log(`📁 [DOWNLOAD] documentFolderPathForCheck (without file://): ${documentFolderPathForCheck}`);
      console.log(`📁 [DOWNLOAD] localFilePath (for download): ${localFilePath}`);
      console.log(`📁 [DOWNLOAD] expectedPathForOpening (matches getOfflineFileUrl): ${expectedPathForOpening}`);
      
      // Check if file already exists (using file.checkFile which expects directory and filename separately, WITHOUT file:// prefix)
      try {
        const fileExists = await this.file.checkFile(documentFolderPathForCheck, documentFileName);
        if (fileExists) {
          if (forceDownload) {
            // Delete existing file to force re-download of updated document
            console.log(`🔄 [DOWNLOAD] Document ${documentFileName} exists but forceDownload=true, deleting old file...`);
            try {
              await this.file.removeFile(documentFolderPathForCheck, documentFileName);
              console.log(`✅ [DOWNLOAD] Deleted old file: ${documentFileName}`);
            } catch (deleteError) {
              console.warn(`⚠️ [DOWNLOAD] Could not delete old file, will overwrite:`, deleteError);
            }
          } else {
          console.log(`ℹ️ [DOWNLOAD] Document ${documentFileName} already exists locally, skipping download`);
          return;
          }
        }
      } catch (error) {
        // File doesn't exist, proceed with download
      }

      // Verify URL has query parameters (SAS token)
      if (!documentDownloadUrl.includes('?')) {
        console.warn(`⚠️ [DOWNLOAD] documentDownloadUrl missing query parameters (SAS token): ${documentDownloadUrl}`);
        console.warn(`⚠️ [DOWNLOAD] This may cause a 404 error. URL should include ?sv=...&se=...&sig=...`);
      }

      // Ensure URL is properly encoded (FileTransfer should handle this, but let's be explicit)
      // The URL should already be properly formatted from the API, but we'll log it for debugging
      const urlToUse = documentDownloadUrl.trim();
      
      console.log(`📥 [DOWNLOAD] Downloading document: ${documentFileName}`);
      console.log(`📥 [DOWNLOAD] From: ${urlToUse.substring(0, 100)}... (length: ${urlToUse.length})`);
      console.log(`📥 [DOWNLOAD] To: ${localFilePath}`);
      console.log(`📥 [DOWNLOAD] Has query params: ${urlToUse.includes('?')}`);
      console.log(`📥 [DOWNLOAD] Query params: ${urlToUse.includes('?') ? urlToUse.substring(urlToUse.indexOf('?')) : 'N/A'}`);
      
      // Download file using FileTransfer
      // Note: FileTransfer.download(url, filePath, trustAllHosts, options)
      // The third parameter (true) means trust all hosts (for self-signed certs)
      // FileTransfer expects a full file system path (not file:// URL)
      const fileTransfer: FileTransferObject = this.fileTransfer.create();
      
      try {
        // Use download with explicit options to ensure URL is not modified
        const fileEntry = await fileTransfer.download(urlToUse, localFilePath, true);
        
        console.log(`✅ [DOWNLOAD] Successfully downloaded document: ${documentFileName}`);
        console.log(`✅ [DOWNLOAD] File entry URL: ${fileEntry.toURL()}`);
        
        // Verify the file was actually downloaded
        // Wait a small delay to ensure file is written to disk
        await new Promise(resolve => setTimeout(resolve, 100));
        
        try {
          // Use path without file:// prefix for file.checkFile
          const fileExists = await this.file.checkFile(documentFolderPathForCheck, documentFileName);
          if (fileExists) {
            console.log(`✅ [DOWNLOAD] Verified: File exists at ${documentFolderPathForCheck}/${documentFileName}`);
          } else {
            console.warn(`⚠️ [DOWNLOAD] Warning: File download reported success but file not found at expected path`);
            console.warn(`⚠️ [DOWNLOAD] Expected directory: ${documentFolderPathForCheck}`);
            console.warn(`⚠️ [DOWNLOAD] Expected filename: ${documentFileName}`);
            console.warn(`⚠️ [DOWNLOAD] File entry URL from download: ${fileEntry.toURL()}`);
          }
        } catch (verifyError) {
          console.warn(`⚠️ [DOWNLOAD] Could not verify file existence:`, verifyError);
          // File might still be accessible even if checkFile fails - this is not critical
          // The file was downloaded successfully, so it should be accessible via the fileEntry URL
          console.log(`ℹ️ [DOWNLOAD] File should still be accessible via: ${fileEntry.toURL()}`);
        }
      } catch (downloadError) {
        // Re-throw to be caught by outer catch block
        throw downloadError;
      }
    } catch (error) {
      console.error(`❌ [DOWNLOAD] Error downloading document ${documentFileName}:`, error);
      // Log more details about the error
      if (error && (error as any).http_status) {
        console.error(`❌ [DOWNLOAD] HTTP Status: ${(error as any).http_status}`);
        console.error(`❌ [DOWNLOAD] Error Code: ${(error as any).code}`);
        if ((error as any).body) {
          console.error(`❌ [DOWNLOAD] Error Body: ${(error as any).body}`);
        }
      }
      if (error && (error as any).source) {
        console.error(`❌ [DOWNLOAD] Source URL: ${(error as any).source}`);
      }
      if (error && (error as any).target) {
        console.error(`❌ [DOWNLOAD] Target Path: ${(error as any).target}`);
      }
      // Don't throw error - allow sync to continue even if download fails
      // The file might be available online or can be retried later
      console.warn(`⚠️ [DOWNLOAD] Continuing sync despite download failure for ${documentFileName}`);
    }
  }
}
